import { ErrorResponse, FgStatusEnum, GlobalStatus, JobCompletedEnum, JobStatusEnum, OperationTypeEnum, Series, UnitRequest, ShiftsEnum, WorkStationTypeEnum, TransactionType } from '@gtpl/shared-models/common-models';
import { BeheadingInventoryDto, BeheadingInventoryResponse, BeheadingReportedQty, InProgressBeHeadingDto, InProgressBeheadingResponse, BeheadingDashboardResponse, ChartInfo, SoakingResponseModel, SoakingDto, LotDetailsResponseModel, LogDetailsResponseModelDto, ProductionLogResponse, OperationsRegisterResponseModel, OperatonsRegisterDto, SubPlantTransferResponse, OperationRegisterRequest, LotNumberReportResponseModel, LotTrackingResponseDto, ProductionLogDetailsResponseModel, ProductionLogDto, ReportingInfoResponseModel, ReportingInfoDto, JobReportingInfoReq, ProductionProcessDashboardReq, BillNumberRequest, BillGenerationReportRequest, TransportChargesReq } from '@gtpl/shared-models/production-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { OperationRequest } from './dto/operation-data.request';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { ProductionLogAdapter } from './dto/production-log.adapter';
import { ProductionLogData } from './dto/production-log.dto';
import { ProductionLogRepository } from './repositories/production-log.repository';
import { WorkstationService } from '@gtpl/shared-services/production';
import { CommonResponse, SaleOrderItemsBySoIdReaponseModel } from '@gtpl/shared-models/sale-management';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { LogIdRequest } from './dto/log-id-request';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { OperationSequenceRequest } from './dto/operation-sequence.request';
import { ProductionLog } from './entities/production-log.entity';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { LotInfoRequest } from './dto/lot-info.request';
import { SubPlantHistoryDto } from 'libs/shared-models/production-management/src/lib/production-log/sub-plant-history.dto';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import appSettings from 'apps/services/config';
import { BillGenerationModel, FinalFortNightDeheading, FirstFortNightDeheading, PlantIdRequest, UnitTypeEnum, FirstFortnightPeeling, ScopeData, FinalFortnightPeeling, FirstPeelingCuttingModel, FinalPeelingCuttingModel, FirstOther, FinalOther, OtherModel } from '@gtpl/shared-models/masters';
import { catchError } from 'rxjs/operators';
import moment from 'moment';
import { getDaysInMonth } from 'date-fns'; 

@Injectable()
export class ProductionLogService {
    constructor(@InjectRepository(ProductionLogRepository)
    private productionLogRepo: ProductionLogRepository,
        @InjectRepository(ProductionInventoryRepository)
        private inventoryRepository: ProductionInventoryRepository,
        @InjectRepository(ProductionLog)
        private productionLogRepository: Repository<ProductionLog>,
        private saleOrderService: SaleOrderService,
        private variantOperationService: VariantOperationsService,
        private unitcodeService: UnitcodeService,
        private workstations: WorkstationService,
        private logAdapter: ProductionLogAdapter) { }

    async CreateProductionLog(inputReq: ProductionLogData) {
        try {
            const convertDtoToEntity = await this.logAdapter.convertDtoToEntity(inputReq);
            const createLog = await this.productionLogRepo.save(convertDtoToEntity);
            // update previous operation status against workstation
            // const updatePreviousOperation = await this.updatePreviousOperationStatus(productionLogData.lotNumber, productionLogData.workStation)
            const savedProdLogDto: ProductionLogData = this.logAdapter.convertEntityToDto(convertDtoToEntity);
            if (savedProdLogDto) {
                // generating resposnse
                const response = new ProductionLogResponse(true, 1, 'ProdLog Created Successfully');
                return response
            } else {
                //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
                throw new ErrorResponse(11106, 'ProdLog saved but issue while transforming into DTO');
            }

        } catch (error) {
            return error
        }
    }

    async getPrevOperations(lotNumber: string, workstation: number, plantId: number, operation: OperationTypeEnum, inputReq: ProductionInventoryData, status?: FgStatusEnum, columnName?: string): Promise<number> {
        let getWorkCompletedQty
        if (columnName == 'plantId') {

            getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId')
                .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId} and production_log.sub_plant_id = 0 and workstation='${workstation}' and lot_number='${lotNumber}' and job_status='${JobCompletedEnum.NO}'`)
                .getRawOne()
        }
        if (columnName == 'subPlantId') {
            getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId')
                .where(`production_log.operation='${operation}' and production_log.sub_plant_id=${plantId} and workstation='${workstation}' and lot_number='${lotNumber}' and job_status='${JobCompletedEnum.NO}'`)
                .getRawOne()
        }

        if (getWorkCompletedQty.productionLogId) {
            return getWorkCompletedQty.productionLogId;
        } else {
            let getWorkDoneQty
            // for different lot prev operation
            if (columnName == 'plantId') {

                getWorkDoneQty = await this.productionLogRepo.createQueryBuilder('production_log')
                    .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId, lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId')
                    .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId}  and production_log.sub_plant_id = 0 and workstation='${workstation}' and job_status='${JobCompletedEnum.NO}'`)
                    .getRawOne()
            }
            if (columnName == 'subPlantId') {
                getWorkDoneQty = await this.productionLogRepo.createQueryBuilder('production_log')
                    .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId, lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId')
                    .where(`production_log.operation='${operation}' and production_log.sub_plant_id=${plantId} and workstation='${workstation}' and job_status='${JobCompletedEnum.NO}'`)
                    .getRawOne()
            }

            if (getWorkDoneQty.productionLogId) {
                return getWorkDoneQty.productionLogId
            } else {
                return 0;
            }
        }
    }

    async updatePreviousOperationStatus(lotNumber: string, workstation: number, plantId: number, operation: OperationTypeEnum, inputReq: ProductionInventoryData, status?: FgStatusEnum) {

        const getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
            .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId')
            .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId} and workstation='${workstation}' and lot_number='${lotNumber}' and job_status='${JobCompletedEnum.NO}'`)
            .getRawOne()
        // for same lot prev operation
        if (getWorkCompletedQty.productionLogId) {

            const updateLog = await this.productionLogRepo.update({
                operationType: Raw(
                    (alias) => `operation = '${operation}'`
                ),
                plantId: Raw(
                    (alias) => `plant_id = '${plantId}'`
                ),
                workstation: Raw(
                    (alias) => `workstation = '${workstation}'`
                ),
            }, { jobStatus: JobCompletedEnum.YES });

            if (updateLog.affected) {
                const jobCompletedInputQty = getWorkCompletedQty.quantity;
                const jobCompletedOutputQty = getWorkCompletedQty.outputQuantity;
                const jobCompletedWastageQty = getWorkCompletedQty.wastageQuantity;
                const updateInfo = this.inventoryRepository.updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, OperationTypeEnum.GRADING, inputReq)
            }
            return updateLog.affected;
        } else {
            // for different lot prev operation
            const getWorkDoneQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId, lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId')
                .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId} and workstation='${workstation}' and job_status='${JobCompletedEnum.NO}'`)
                .getRawOne()
            if (getWorkDoneQty.productionLogId) {
                const updateLog = await this.productionLogRepo.update({
                    operationType: Raw(
                        (alias) => `operation = '${operation}'`
                    ),
                    plantId: Raw(
                        (alias) => `plant_id = '${plantId}'`
                    ),
                    workstation: Raw(
                        (alias) => `workstation = '${workstation}'`
                    ),
                }, { jobStatus: JobCompletedEnum.YES });



                if (updateLog.affected) {
                    const jobCompletedInputQty = getWorkDoneQty.quantity;
                    const jobCompletedOutputQty = getWorkDoneQty.outputQuantity;
                    const jobCompletedWastageQty = getWorkDoneQty.wastageQuantity;
                    const prevInventory: ProductionInventoryData = inputReq;
                    prevInventory.lotNumber = getWorkDoneQty.lotNumber;
                    prevInventory.subLotNumber = getWorkDoneQty.subLotNumber;
                    prevInventory.saleOrderId = getWorkDoneQty.saleOrderId;
                    prevInventory.saleOrderItemId = getWorkDoneQty.saleOrderItemId;

                    const updateInfo = this.inventoryRepository.updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, OperationTypeEnum.GRADING, prevInventory)
                }
                return updateLog.affected;
            }
            return true;
        }

    }

    async updateBeheadingJobCompleted(productionLogId: number, transManager?: GenericTransactionManager, columnName?: string, opBoxes?: number, outputQuantity?: number): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            let nextOperation
            let getWorkCompletedQty
            getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('production_log.input_quantity as quantity, production_log.actual_output_quantity as outputQuantity, production_log.wastage_quantity as wastageQuantity, production_log.lot_number as lotNumber, production_log.sub_lot_number as subLotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId, production_log.operation as operation, production_log.plant_id as plantId,production_log.sub_plant_id as subPlantId, production_log.op_boxes as opBoxes')
                .where(`production_log.production_log_id='${productionLogId}'`)
                .getRawOne()
            if (getWorkCompletedQty) {
                const inventoryData = new ProductionInventoryData();
                inventoryData.lotNumber = getWorkCompletedQty.lotNumber;
                inventoryData.subLotNumber = getWorkCompletedQty.subLotNumber;
                inventoryData.saleOrderId = getWorkCompletedQty.saleOrderId;
                inventoryData.saleOrderItemId = getWorkCompletedQty.saleOrderItemId;
                inventoryData.operation = getWorkCompletedQty.operation;
                inventoryData.plantId = getWorkCompletedQty.plantId;
                inventoryData.subPlantId = getWorkCompletedQty.subPlantId;
                inventoryData.opBoxes = opBoxes;
                if (!columnName && getWorkCompletedQty.subPlantId > 0) {
                    columnName = 'subPlantId'
                }
                if (!columnName && getWorkCompletedQty.subPlantId == 0) {
                    columnName = 'plantId'
                }

                if (getWorkCompletedQty.operation == OperationTypeEnum.VALUE_ADDITION) {
                    const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(getWorkCompletedQty.plantId, getWorkCompletedQty.operation, getWorkCompletedQty.saleOrderItemId));

                    nextOperation = opSequence.data.nextOperation;
                } else {
                    nextOperation = OperationTypeEnum.GRADING
                }


                if (nextOperation) {
                    let updateLog
                    if (transManager) {
                        updateLog = await transManager.getCustomRepository(ProductionLogRepository).update({
                            productionLogId: Raw(
                                (alias) => `production_log_id = '${productionLogId}'`
                            ),
                        }, { jobStatus: JobCompletedEnum.YES });
                    } else {
                        await manager.startTransaction();
                        updateLog = await manager.getCustomRepository(ProductionLogRepository).update({
                            productionLogId: Raw(
                                (alias) => `production_log_id = '${productionLogId}'`
                            ),
                        }, { jobStatus: JobCompletedEnum.YES, outputBoxes: opBoxes });
                    }


                    if (updateLog.affected) {
                        const jobCompletedInputQty = getWorkCompletedQty.quantity;
                        const jobCompletedOutputQty = getWorkCompletedQty.outputQuantity;
                        const jobCompletedWastageQty = getWorkCompletedQty.wastageQuantity;
                        let updateInfo;
                        if (transManager) {
                            updateInfo = await transManager.getCustomRepository(ProductionInventoryRepository).updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, nextOperation, inventoryData, columnName);
                        } else {
                            updateInfo = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, nextOperation, inventoryData, columnName);
                        }


                        if (updateInfo) {
                            if (!transManager) {
                                await manager.completeTransaction();
                            }
                        } else {
                            await manager.releaseTransaction();
                            throw new ErrorResponse(9999, 'Failed To Report');
                        }
                    } else {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(9999, 'Failed To Report');
                    }
                    return new CommonResponse(true, 1111, 'Job Reported Successfully');
                } else {
                    await manager.releaseTransaction();
                    throw new ErrorResponse(9999, 'No operation sequence found or saleorder');
                }
            } else {
                throw new ErrorResponse(9999, 'Failed To Report');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error
        }


    }
    async updateOutputGradeAndOperationStatus(productionLogId: number, workStation: number, lotNumber: string, outputGrade: number, outputQuantity: number, nextOperation: OperationTypeEnum, inputQuantity: number, manager: GenericTransactionManager): Promise<boolean> {
        const updateInfo = await this.inventoryRepository.updateInventoryOutPutGrade(lotNumber, outputGrade, workStation, outputQuantity, nextOperation, inputQuantity);
        console.log(updateInfo);
        if (updateInfo) {
            const updateLog = await manager.getCustomRepository(ProductionLogRepository).update({
                productionLogId: Raw(
                    (alias) => `production_log_id = '${productionLogId}'`
                ),
            }, { actualGrade: String(outputGrade), jobStatus: JobCompletedEnum.YES, actualOutputQuantity: outputQuantity });
            console.log(updateLog);
            if (updateLog.affected > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    async getWorkstationWiseInprogressData(req: OperationRequest): Promise<InProgressBeheadingResponse> {
        try {
            const response = await this.productionLogRepo.getWorkstationWiseInprogressData(req.operationType, req.plantId)
            if (response && response.length) {
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }

    }
    async getBeheadingInventoryData(req: OperationRequest): Promise<BeheadingInventoryResponse> {
        try {
            const response = await this.productionLogRepo.getBeheadingInventoryDetails(req.operationType, req.plantId)
            if (response && response.length) {
                const beheadingData: BeheadingInventoryDto[] = [];
                for (const res of response) {
                    const saleOrderNo = await this.saleOrderService.getSaleOrderDetailsById({ saleOrderId: res.saleOrderId })
                    beheadingData.push(new BeheadingInventoryDto(res.lotNumber, res.saleOrderId, saleOrderNo.data.saleOrder, res.jobNumber, res.subPlant, res.workstationType, res.inputQuantity, res.plannedOutputQuantity, res.boxes, res.workStationId, res.jobStatus, res.createdUser, res.updatedUser));
                }
                console.log(beheadingData);
                return new BeheadingInventoryResponse(true, 1111, 'Beheading inventory information found successfully', beheadingData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getOperationQuantity(lotNumber: string, plantId: number, operation: OperationTypeEnum) {
        const operationQuantity: BeheadingReportedQty = await this.productionLogRepo.getOperationQuantity(lotNumber, plantId, operation)
        return operationQuantity;
    }

    async getExternalPlantInfo(plantId: number, operation: OperationTypeEnum) {
        const externalPlantInfo = await this.productionLogRepo.getExternalPlantInfo(plantId, operation)
        return externalPlantInfo;
    }

    async getAllBeheadingInfo(plantId: number, operation: OperationTypeEnum): Promise<BeheadingDashboardResponse> {
        try {
            const workstationInfo = await this.productionLogRepo.getAllBeheadingInfo(plantId, operation)
            console.log(workstationInfo);
            if (workstationInfo && workstationInfo.length) {
                const categories: string[] = [];
                for (const workstation of workstationInfo) {
                    if (!categories.includes(workstation.workstation))
                        categories.push(workstation.workstation);
                }

                const statuses: string[] = [JobCompletedEnum.NO, JobCompletedEnum.YES];
                const series: Series[] = []

                for (const status of statuses) {
                    const ser = new Series();
                    ser.name = (status == JobCompletedEnum.NO) ? 'In-Progress' : 'Completed';
                    const details: number[] = [];
                    let ifNoData = true;
                    for (const station of categories) {
                        ifNoData = true;
                        for (const inprogress of workstationInfo) {
                            if (status == inprogress.job_status && station == inprogress.workstation) {
                                ifNoData = false;
                                details.push(Number(Number(inprogress.inputQuantity / 1000).toFixed(3)))
                            }
                        }
                        if (ifNoData) {
                            details.push(0);
                        }
                    }
                    ser.data = details;
                    series.push(ser);
                }
                const chartData = new ChartInfo();
                chartData.data = series;
                chartData.xaxis = categories
                return new BeheadingDashboardResponse(true, 1111, 'Beheading inventory information found successfully', chartData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }

        } catch (error) {
            return error;
        }

    }




    async getLotDetailsById(req: LogIdRequest): Promise<LotDetailsResponseModel> {
        console.log('getLotDetailsByIdService' + req.productionLogid);
        const response = await this.productionLogRepo.getLogDetailsById(req.productionLogid);
        console.log(response, 'response??????');
        if (response) {
            const saleOrderNo = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: response.saleOrderId });
            const workStation = await this.workstations.getWorkstationCapacity({ workstationId: response.workStationId, unitId: response.plantId });
            const data = new LogDetailsResponseModelDto(response.productionLogId, response.lotNumber, response.subLotNumber, response.saleOrderId, saleOrderNo.poNumber, response.operation, response.nextOperation, response.inputQuantity, response.plannedGrade, response.soakingTime, response.soakingStyle, response.assignedTime, response.workStationId, workStation.data.workstation, response.saleOrderItemId);
            return new LotDetailsResponseModel(true, 1001, 'Log Details retrived Successfully. ', data);
        }
        else {
            return new LotDetailsResponseModel(false, 1001, 'no data found. ');
        }
    }
    // async getAllSoakingInfos(req: UnitRequest): Promise<SoakingResponseModel> {
    //     try {
    //         const response = await this.productionLogRepo.getSoakingDetails(OperationTypeEnum.SOAKING, req.unitId)
    //         console.log('response..',response)
    //         if (response && response.length) {
    //             const soakingData: SoakingDto[] = [];
    //             for (const res of response) {
    //                 console.log('currentres',res)
    //                 const saleOrderDetails = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId })
    //                 console.log(saleOrderDetails,'sad');
    //                 let saleOrderItemDetails: SaleOrderItemsBySoIdReaponseModel;
    //                 let varient = "";
    //                 console.log(res.saleOrderItemId,'res.saleOrderItemId,,,')
    //                 if (res.saleOrderItemId != null) {
    //                     saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: res.saleOrderId, saleOrderItemId: res.saleOrderItemId });
    //                     varient = saleOrderItemDetails.data?.variety;
    //                 }
    //                 console.log(res.workStationId,'workStationId///')
    //                 const workStation = await this.workstations.getWorkstationCapacity({ workstationId: res.workStationId, unitId:req.unitId })
    //                 console.log(workStation)
    //                 soakingData.push(new SoakingDto(res.productionLogId, res.jobNumber, res.lotNumber, res.workStationType, res.saleOrderId, saleOrderDetails.saleOrderNumber, varient, res.soakingStyle, res.soakingTime, res.inputQuantity, res.jobStatus, res.assignFreezing, res.shift, res.assignedTime, res.subPlant, res.createdUser, res.workStationId, workStation.data.workstation, res.saleOrderItemId, res.plannedGrade, res.outputGrade, res.operation, 0, ' ', 0, saleOrderDetails.poNumber));
    //             }
    //             return new SoakingResponseModel(true, 1111, 'Soaking inventory information found successfully', soakingData);
    //         } else {
    //             throw new ErrorResponse(9999, 'No Data Found');
    //         }
    //     } catch (error) {
    //         console.log(error,'errorrr--')
    //         return error
    //     }
    // }
    async getAllSoakingInfo(req: UnitRequest): Promise<SoakingResponseModel> {
        const manager = getManager();
        let query
        query = 'SELECT  gi.remarks as plantLotNumber,CONCAT(pl.sub_lot_number,IF(gi.remarks IS NOT NULL,"-",""),IF(gi.remarks IS NOT NULL,gi.remarks,"")) as plantAndSubLotNumber,CONCAT(po_number,"-",sk.`variant_code`) AS item,sk.`variant_code` as variantCode,sid.po_number as poNumber,w.workstation,production_log_id AS productionLogId,job_number AS jobNumber,pl.lot_number AS lotNumber,pl.sub_lot_number AS subLotNumber,pl.plant_id AS plantId,workstation_type AS workstationType,pl.workstation AS workstationId,input_quantity AS physicalQuantity,job_status AS jobStatus,pl.sale_order_id AS saleOrderId,pl.sale_order_item_id AS saleOrderItemId,assign_freezing AS assignFreezing,sub_plant_id AS subPlantId,pl.input_quantity AS inputQuantity,pl.planned_output_quantity AS plannedOutputQuantity,pl.soaking_time AS soakingTime,pl.soaking_style AS soakingStyle,shift AS shift,pl.assigned_time AS assignedTime,input_grade AS inputGrade,actual_grade AS outputGrade FROM ' + appSettings.production_db + '.`production_log` pl LEFT JOIN ' + appSettings.production_db + '.`workstations` w ON w.`workstation_id`=pl.`workstation` LEFT JOIN ' + appSettings.sales_db + '.`so_invoice_details` sid ON sid.`sale_order_id`=pl.`sale_order_id`LEFT JOIN ' + appSettings.sales_db + '.`sale_order_items` soi ON soi.`sale_order_id`=pl.`sale_order_id` AND soi.`sale_order_item_id`=pl.`sale_order_item_id` LEFT JOIN ' + appSettings.masters_db + '.`sku_codes` sk ON sk.`sku_code_id`=soi.`varient_id` LEFT JOIN ' + appSettings.rm_procure_db + '.grn_items gi on gi.lot_number=pl.lot_number  where pl.operation="SOAKING" '
        const plantquery = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId + '';
        const plantdata = await manager.query(plantquery)
        if (plantdata.plant_type == UnitTypeEnum.SUB_PLANT) {
            query = query + ' and pl.sub_plant_id=' + req.unitId + ''
        } else {
            query = query + ' and pl.plant_id=' + req.unitId + ' and pl.sub_plant_id=0'
        }
        const result = await manager.query(query);
        if (result) {
            return new SoakingResponseModel(true, 1111, 'Soaking inventory information found successfully', result);
        }
        else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getAllBeheadingInProgressJobs(unitId: number, operation: OperationTypeEnum): Promise<InProgressBeheadingResponse> {
        try {
            const manager = getManager();
            const PlantTypeQuery = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + unitId;
            const result = await manager.query(PlantTypeQuery);
            var query = `SELECT gi.remarks as plantLotNumber,CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,log.production_log_id as productionLogId, log.lot_number as lotNumber, log.sub_lot_number as subLotNumber, log.workstation_type as workstationType, w.workstation as workstation, round(log.input_quantity) as quantity, log.operation, log.plant_id as plantId, log.sub_plant_id as subPlantId, log.created_user as createdUser, log.updated_user as updatedUser,log.assigned_time as assignedTime, job_status as jobStatus, log.job_number as jobNumber, log.dc_number as dcNumber, log.mrn_number as mrnNumber, log.sale_order_id as saleOrderId, log.sale_order_item_id as saleOrderItemId, log.ip_boxes as ipBoxes, log.actual_output_quantity as physicalQuantity, sku.variant_code as varietyOfMaterial, si.varient_id as variety , log.op_boxes AS opBoxes, w.workstation_unit_capacity AS workstationCapacity
               FROM `+ appSettings.production_db + `.production_log log 
              LEFT JOIN `+ appSettings.production_db + `.workstations w ON log.workstation=w.workstation_id
              LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=log.sale_order_item_id
              LEFT JOIN `+ appSettings.masters_db + `.sku_codes sku ON sku.sku_code_id=si.varient_id LEFT JOIN ` + appSettings.rm_procure_db + `.grn_items gi on log.lot_number=gi.lot_number where
              log.operation='${operation}' and job_status='${JobCompletedEnum.NO}' and workstation_type='${WorkStationTypeEnum.INTERNAL}'`
            if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
                query += "AND log.sub_plant_id=" + unitId;
            } else {
                query += "AND log.plant_id=" + unitId + ' and log.sub_plant_id = 0';
            }
            const response = await manager.query(query);
            // const response = await this.productionLogRepo.getAllBeheadingInProgressJobs(operation, unitId)
            if (response?.length) {
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }


    async getAllBeheadingExternalPlantJobs(unitId: number, operation: OperationTypeEnum): Promise<InProgressBeheadingResponse> {
        try {
            const response = await this.productionLogRepo.getAllBeheadingExternalPlantJobs(operation, unitId)
            if (response && response.length) {
                for (const res of response) {
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId })

                    res.saleOrder = (saleOrderDetails) ? saleOrderDetails.saleOrderNumber : '';
                    res.poNumber = (saleOrderDetails) ? saleOrderDetails.poNumber : '';

                }
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getAllExternalPlantLots(unitId: number): Promise<CommonResponse> {
        try {
            const response = await this.productionLogRepo.getAllExternalPlantLots(unitId)
            if (response && response.length) {
                for (const res of response) {
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderDetailsById({ saleOrderId: res.saleOrderId })
                    res.saleOrder = saleOrderDetails.data.saleOrder;
                }
                return new CommonResponse(true, 1111, 'External Plant Info found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }


    async getAllBeheadingPlantJobs(unitId: number, operation: OperationTypeEnum): Promise<InProgressBeheadingResponse> {
        try {
            const response = await this.productionLogRepo.getAllBeheadingPlantJobs(operation, unitId)
            if (response && response.length) {
                for (const res of response) {
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId })
                    res.saleOrder = saleOrderDetails.saleOrderNumber;
                    res.poNumber = saleOrderDetails.poNumber;
                }
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    // async getAllOperationReports(req?: OperationRegisterRequest): Promise<OperationsRegisterResponseModel> {
    //     try {
    //         let operatonsRegisterDto: OperatonsRegisterDto[] = [];
    //         // retrieves all plants
    //         // const operationRegisterDetails : OperationRegisterDTO[] = await this.productionLogRepository.find({
    //         //     order: { createdAt: "DESC" },
    //         // });


    //         const operationRegisterDetails = await this.productionLogRepository.createQueryBuilder("ProductionLog")
    //             .leftJoinAndSelect('ProductionLog.workstation', 'workstation')
    //             .getMany();

    //         if (operationRegisterDetails.length > 0) {
    //             let soNumber = null;
    //             for (const entity of operationRegisterDetails) {

    //                 const soData = (await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: entity.saleOrderId }));

    //                 if (soData.saleOrderId > 0) {
    //                     soNumber = soData.saleOrderNumber ? soData.saleOrderNumber : ''
    //                 }
    //                 //soNumber= "hello";
    //                 const operationregisterData: OperatonsRegisterDto =
    //                     //new OperatonsRegisterDto(1,"lot number",'1',3,"abc",1,"op","job no",1,"workstaton type",JobStatusEnum.DONE,"workstation",1,3,2,11,11,11,11,11,"me","12:30",1,ShiftsEnum.General,"me","me");
    //                     new OperatonsRegisterDto(entity.productionLogId, entity.lotNumber, entity.subLotNumber, entity.saleOrderId, soNumber, entity.saleOrderItemId, entity.operationType, entity.jobNumber, entity.subPlantId, entity.workStationType, entity.jobStatus, (entity.workstation) ? entity.workstation.workstation : '', entity.inputGrade, entity.plannedGrade, entity.actualGrade, entity.inputQuantity, entity.plannedOutputQuantity, entity.actualOutputQuantity, entity.inputBoxes, entity.outputBoxes, entity.assignedUser, entity.assignedTime, entity.plantId, entity.shift, entity.createdUser, entity.updatedUser);

    //                 // console.log(stockDtoData)
    //                 operatonsRegisterDto.push(operationregisterData);
    //             };
    //             // console.log(operatonsRegisterDto)

    //             if (operatonsRegisterDto) {
    //                 const response = new OperationsRegisterResponseModel(true, 11208, "Data Retrived successfully", operatonsRegisterDto);
    //                 return response;
    //             }
    //         } else {
    //             throw new ErrorResponse(99998, 'No Records Found');
    //         }
    //     } catch (err) {
    //         return err;
    //     }
    // }
    async getAllOperationReports(req?: OperationRegisterRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = "SELECT lot_number as lotNumber,sub_lot_number as subLotNumber,so.sale_order_no as saleOrderNumber,operation,sub_plant_id as subPlantId,job_number as jobNumber,workstation_type as workstationType,w.workstation,input_grade as inputGrade,planned_grade as plannedGrade,actual_grade as actualGrade,input_quantity as inputQuantity,planned_output_quantity as plannedOutputQuantity,actual_output_quantity as actualOutputQuantity,ip_boxes as ipBoxes,op_boxes as opBoxes,shift FROM `erpx_dev_production`.`production_log` p LEFT JOIN `erpx_dev_sales`.`sale_order` so ON so.sale_order_id = p.sale_order_id LEFT JOIN `erpx_dev_production`.`workstations` w ON  w.workstation_id = p.workstation"

            //   if(req.unitId && req.unitId != 5){
            //     if(req.lotNumber == undefined && req.fromDate == undefined && req.toDate == undefined){
            //     query = query+  'and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id';

            //     }
            //     if(req.lotNumber){
            //       query=query+' AND pl.lot_number = "'+req.lotNumber+'" and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id'
            //     }
            //     if(req.fromDate && req.toDate){
            //         query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id';
            //     }
            //     if(req.lotNumber && req.fromDate && req.toDate){
            //         query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber+'" and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id' ;
            //     }
            //   }
            //   else{
            //        if(req.lotNumber){
            //       query=query+' AND pl.lot_number= "'+req.lotNumber+'" GROUP BY pl.lot_number,pl.sale_order_item_id';
            //     }
            //     if(req.fromDate && req.toDate){
            //         query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"GROUP BY pl.lot_number,pl.sale_order_item_id' ;
            //     }
            //     if(req.lotNumber && req.fromDate && req.toDate){
            //       query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber+'" GROUP BY pl.lot_number,pl.sale_order_item_id' ;
            //   }
            //   }

            const data = await manager.query(query)

            if (data.length > 0) {
                return new CommonResponse(true, 1001, "Lots retrieved successfully. ", data);
            }
            else {
                return new CommonResponse(false, 1010, "No data found. ");
            }
        }
        catch (err) {
            return err
        }
    }


    async getLogDetailsForId(productionLogId: number): Promise<SubPlantTransferResponse> {
        try {
            const response = await this.productionLogRepo.getLogDetailsForId(productionLogId)
            if (response) {
                // const saleOrderDetails = await this.saleOrderService.getSaleOrderDetailsById({ saleOrderId: res.saleOrderId })
                // response.saleOrder =saleOrderDetails.data.saleOrder;
                if (response.itemId != null) {
                    const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: response.itemId })
                    console.log(soItemInfo);
                    response.itemName = soItemInfo.data.product;
                }
                return new SubPlantTransferResponse(true, 1111, 'Transfer information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getLotTrackingReportData(req: LotInfoRequest): Promise<LotNumberReportResponseModel> {

        const lotDetails = await this.productionLogRepo.getLotInformation(req);
        console.log('lotDetails' + lotDetails);
        const responseData: LotTrackingResponseDto[] = [];
        for (const lot of lotDetails) {
            console.log(lot);
            const workStation = await this.workstations.getWorkstationCapacity({ workstationId: lot.workstation, unitId: lot.plantId });
            console.log(workStation.data);
            const data = new LotTrackingResponseDto(lot.lotNumber, lot.inputQuantity, lot.plannedOutputQuantity, workStation.status ? workStation.data.workstation : "", lot.operation, lot.jobNumber, lot.jobStatus, lot.assignedTime);
            responseData.push(data);
        }
        return new LotNumberReportResponseModel(true, 1001, "lot details retrived successfully. ", responseData);
    }
    async getSubPlantHistoryDetails(req: UnitRequest): Promise<ProductionLogDetailsResponseModel> {
        try {
            // const subPlantData = await this.productionLogRepo.getSubPlantHistory(req.unitId);
            // console.log(subPlantData);
            // if (subPlantData.length && subPlantData) {
            //     const logData: SubPlantHistoryDto[] = [];
            //     for (const lot of subPlantData) {
            //         const soData = (await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: lot.saleOrderId }));
            //         const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: lot.plantId });
            //         const plantName = plantDetails.status ? plantDetails.data.unitcodeName : "";
            //         const subPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: lot.subPlantId });
            //         const subPlantName = subPlantDetails.status ? subPlantDetails.data.unitcodeName : "";
            //         const data = new SubPlantHistoryDto(lot.productionLogId, lot.operationType, lot.lotNumber, lot.subLotNumber, lot.jobNumber, lot.saleOrderId, lot.saleOrderItemId, lot.plantId, lot.subPlantId, lot.workStationType, lot.jobStatus, lot.assignFreezing, lot.workstation, lot.inputGrade, lot.plannedGrade, lot.actualGrade, lot.inputQuantity, lot.plannedOutputQuantity, lot.actualOutputQuantity, lot.inputBoxes, lot.outputBoxes, lot.assignedUser, lot.assignedTime, lot.shift, lot.isReceived, lot.operation, soData.saleOrderNumber, plantName, subPlantName, lot.wipQuantity, soData.poNumber);
            //         logData.push(data);
            //     }

            const manager = getManager();
            const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId;
            const result = await manager.query(query);
            //  var dataQuery = `SELECT production_log_id as productionLogId,job_number as jobNumber, workstation as workstation, production_log.input_grade as inputGrade, (production_log.input_quantity) as inputQuantity, job_status as jobStatus, production_log.operation as operationType,CONCAT(production_log.lot_number , " - ",gi.remarks) as lotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId, (production_log.op_boxes) as opBoxes, assigned_time as assignedTime, production_log.sub_lot_number as subLotNumber, production_log.plant_id as plantId, production_log.sub_plant_id as subPlantId,production_log.workstation_type as workStationType, production_log.assign_freezing as assignFreezing,planned_grade as plannedGrade , actual_grade as actualGrade, (planned_output_quantity) as plannedOutputQuantity,(actual_output_quantity) as actualOutputQuantity, (ip_boxes) as inputBoxes,(production_log.op_boxes) as outputBoxes, assigned_user as assignedUser,assigned_time as assignedTime, shift as shift, sub_plant_op_status as isReceived, production_log.operation, productionInventory.wip_quantity as wipQuantity,sid.po_number as poNumber , uc.unit_name as plantName , ucs.unit_name as subPlantName FROM ` + appSettings.production_db + `.production_log production_log LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number = production_log.lot_number LEFT JOIN ` + appSettings.production_db + `.production_inventory productionInventory ON productionInventory.prod_inv_id = production_log.prod_inv_id LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = production_log.sale_order_id LEFT JOIN `+appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = production_log.plant_id LEFT JOIN `+appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = production_log.sub_plant_id  WHERE production_log.workstation_type = '${WorkStationTypeEnum.EXTERNAL}' `
            var dataQuery = `SELECT pi.operation, stl.send_boxes as inputBoxes,receive_boxes as outputBoxes,pi.wip_quantity as wipQuantity,pi.physical_quantity AS inputQuantity, uc.unit_name as plantName , ucs.unit_name as subPlantName, CONCAT(pi.lot_number,"-",gi.remarks) as lotNumber,sid.po_number as poNumber from ` + appSettings.production_db + `.stock_transfer_log stl LEFT JOIN ` + appSettings.production_db + `.production_inventory pi on pi.prod_inv_id = stl.new_production_inv_id LEFT JOIN ` + appSettings.rm_procure_db + `.grn_items gi on gi.lot_number = pi.lot_number LEFT JOIN  ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = pi.plant_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = stl.sub_plant_id where stl.transfer_log_id > 0 `;
            //  if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
            //     dataQuery += "AND stl.sub_plant_id="+req.unitId;
            //   }else{
            dataQuery += " AND stl.plant_id=" + req.unitId;
            //   }
            const subPlantHistory = await manager.query(dataQuery);

            if (subPlantHistory.length > 0) {
                const response = new ProductionLogDetailsResponseModel(true, 1001, 'ProdLog Created Successfully', subPlantHistory);
                return response;
            }
            else {
                const response = new ProductionLogDetailsResponseModel(false, 1010, 'No Data Found. ');
                return response;
            }
        }
        catch (error) {
            return error
        }
    }

    async getTransactionDetails(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId;
            const result = await manager.query(query);
            var dataQuery = `SELECT production_log_id as productionLogId,job_number as jobNumber, workstation as workstation, production_log.input_grade as inputGrade, (production_log.input_quantity) as inputQuantity, job_status as jobStatus, production_log.operation as operationType, concat(production_log.lot_number,"-",gi.remarks) as lotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId, (production_log.op_boxes) as opBoxes, assigned_time as assignedTime, production_log.sub_lot_number as subLotNumber, production_log.plant_id as plantId, production_log.sub_plant_id as subPlantId,production_log.workstation_type as workStationType, production_log.assign_freezing as assignFreezing,planned_grade as plannedGrade , actual_grade as actualGrade, (planned_output_quantity) as plannedOutputQuantity,(actual_output_quantity) as actualOutputQuantity, (ip_boxes) as inputBoxes,(production_log.op_boxes) as outputBoxes, assigned_user as assignedUser,assigned_time as assignedTime, shift as shift, sub_plant_op_status as isReceived, production_log.operation, productionInventory.wip_quantity as wipQuantity,sid.po_number as poNumber , uc.unit_name as fromPlantName , ucs.unit_name as toPlantName FROM ` + appSettings.production_db + `.production_log LEFT JOIN ` + appSettings.rm_procure_db + `.grn_items gi on gi.lot_number = production_log.lot_number LEFT JOIN ` + appSettings.production_db + `.production_inventory productionInventory ON productionInventory.prod_inv_id = production_log.prod_inv_id LEFT JOIN  ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = production_log.sale_order_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = production_log.plant_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = production_log.sub_plant_id  WHERE production_log.production_log_id > 0 ' `
            if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
                dataQuery += "AND production_log.sub_plant_id=" + req.unitId;
            } else {
                dataQuery += "AND production_log.plant_id=" + req.unitId + ' and production_log.sub_plant_id = 0';
            }
            const subPlantHistory = await manager.query(dataQuery);

            if (subPlantHistory.length > 0) {
                const response = new ProductionLogDetailsResponseModel(true, 1001, 'ProdLog Created Successfully', subPlantHistory);
                return response;
            }
            else {
                const response = new ProductionLogDetailsResponseModel(false, 1010, 'No Data Found. ');
                return response;
            }
        }
        catch (error) {
            return error
        }
    }


    async getAllReportingInfo(req: JobReportingInfoReq): Promise<ReportingInfoResponseModel> {
        const manager = getManager()
        try {
            // const toDate = '2024-07-16'
            // const fromDate = '2024-07-4'
            const ReportingDto: ReportingInfoDto[] = [];
            //     const ReportingEntities:ProductionLog[]=await this.productionLogRepository.find({
            //         select:['jobNumber','prevOperation','operationType','inputGrade','actualGrade','inputQuantity','actualOutputQuantity','product','workStationType','shift'],
            //         where:{operationType:req.operation,lotNumber:req.lotNumber}
            //     },
            // );

            let infoQuery = `SELECT pl.job_number as jobNumber,pl.lot_number as lotNumber,lc.grading_test_result as result,
       pl.prev_operation as prevOperation,pl.operation as operationType,pl.input_grade as inputGrade,
        pl.actual_grade as actualGrade,pl.input_quantity as inputQuantity,pl.actual_output_quantity as actualOutputQuantity,
        pl.product as product,pl.workstation_type as workStationType,pl.shift as shift,pl.is_rrp as isRRP,pl.rejection_from as rejectionFrom,pl.year,pl.planned_grade as plannedGrade
        FROM ${appSettings.production_db}.production_log pl
        left join ${appSettings.production_db}.lot_code_data lc on lc.lot_number = pl.lot_number
         WHERE pl.production_log_id > 0 `
            if (req.lotNumber) {
                infoQuery += ` AND pl.lot_number = '${req.lotNumber}'`
            }
            if (req.operation) {
                infoQuery += ` AND pl.operation = '${req.operation}'`;
            }
            if (req.status) {
                infoQuery += ` AND lc.grading_test_result= '${req.status}'`;
            }
            // if (req.fromDate){
            //     infoQuery += ` AND pl.created_at = ${req.fromDate}`
            // }
            // if (req.toDate){
            //     infoQuery += ` AND pl.created_at = ${req.toDate}`
            // }

            // infoQuery += ` AND DATE(pl.created_at) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            if (req.fromDate && req.toDate) {
                infoQuery += 'AND Date (pl.date) BETWEEN "' + req.fromDate + '" and "' + req.toDate + '"';
            }

            const info = await manager.query(infoQuery)
            console.log(info, '----')
            if (info && info.length > 0) {
                info.forEach(reportingEntity => {
                    ReportingDto.push(new ReportingInfoDto(reportingEntity.jobNumber, reportingEntity.lotNumber, reportingEntity.prevOperation, reportingEntity.operationType, reportingEntity.inputGrade, reportingEntity.actualGrade, reportingEntity.inputQuantity, reportingEntity.actualOutputQuantity, reportingEntity.product, reportingEntity.workStationType, reportingEntity.shift, reportingEntity.result,reportingEntity.isRRP,reportingEntity.rejectionFrom,reportingEntity.year,
                    reportingEntity.plannedGrade
                    ));

                });
                const response = new ReportingInfoResponseModel(true, 1001, 'succesfully', ReportingDto)
                return response;

            } else {
                throw new ReportingInfoResponseModel(false, 1010, 'data not found')
            }
        } catch (err) {
            return err;
        }
    }

    async getLotNumberDetails(): Promise<CommonResponse> {
        const manager = getManager();
        try {
            let lotNumberquery = `SELECT pl.lot_number AS lotNumber
             FROM ${appSettings.production_db} .production_log pl
              GROUP BY pl.lot_number`

            const infoQuery = await manager.query(lotNumberquery)

            if (infoQuery.length > 0) {
                const response = new CommonResponse(true, 1001, "successfully", infoQuery)
                return response;
            } else {
                throw new CommonResponse(false, 1010, 'data not found')
            }
        } catch (err) {
            return err;
        }
    }

    async getIntakeDetailsForProductionDashboard(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();

        // Format the date without modifying it
        req.date = moment(req.date).format('YYYY-MM-DD');

        let query = `SELECT gi.grn_item_id, gi.plant_lot_number AS lotNumber, SUM(gi.reweighment_quantity+IF(gd.quantity>0,gd.quantity,0)) AS reweighmentQuantity,
            SUM(gi.quantity) as quantity, gi.count, gi.farmer,
            DATE(gi.reweighment_date) AS reWeighingDate, su.name AS farmerName,gi.reweighment_count AS reweighmentCount
            FROM erpx_dev_rm_procurement.grn_items gi
            LEFT JOIN erpx_dev_rm_procurement.grn g ON g.grn_id=gi.grn_id
            LEFT JOIN erpx_dev_rm_procurement.grn_item_defects gd ON gd.grn_item_id=gi.grn_item_id 
            LEFT JOIN erpx_dev_masters.suppliers su ON su.supplier_id = COALESCE(gi.farmer, gi.broker)
            WHERE gi.grn_item_id > 0 AND gi.plant_lot_number IS NOT NULL  AND DATE(gi.reweighment_date) = '${req.date}' 
            GROUP BY COALESCE(gi.farmer, gi.broker), gi.count , gi.plant_lot_number
            ORDER BY DATE(gi.reweighment_date)`;

        const data = await manager.query(query);

        if (data) {
            return new CommonResponse(true, 1, "Intake Details Retrieved Successfully", data);
        } else {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
    }

    async getSoakingDataForProductionReport(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
       let date = moment(req.date).format('YYYY-MM-DD');
       let query = `SELECT  
       pl.production_log_id AS production_log_id,
       DATE(pl.date) AS createdAt,

       CASE 
           WHEN pl.rejection_from LIKE '%/%' AND pl.rejection_from RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.rejection_from, 1, LENGTH(pl.rejection_from) - LOCATE('-', REVERSE(pl.rejection_from)))
           ELSE pl.rejection_from 
       END AS rejectionFrom,

       CASE 
           WHEN pl.soakingout_product LIKE '%/%' AND pl.soakingout_product RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.soakingout_product, 1, LENGTH(pl.soakingout_product) - LOCATE('-', REVERSE(pl.soakingout_product)))
           ELSE pl.soakingout_product 
       END AS soakingOutProduct,

       CASE 
           WHEN pl.product LIKE '%/%' AND pl.product RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.product, 1, LENGTH(pl.product) - LOCATE('-', REVERSE(pl.product)))
           ELSE pl.product 
       END AS product,

       SUM(IF(pl.operation = 'SOAKING', pl.input_quantity, 0)) AS inputQuantity,
       SUM(IF(pl.operation = 'PACKING', pl.actual_output_quantity, 0)) AS actualOutputQuantity

       FROM  ${appSettings.production_db}.production_log pl
       LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.short_code = pl.product
       WHERE  pl.operation IN ('SOAKING', 'PACKING') 
       AND DATE(pl.date) = '${req.date}' 
       AND process_type IN ('FRESHPRODUCITON','REPROCESS')
       AND rejection_from IS NULL 
       AND soakingout_product IS NULL 

       GROUP BY sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.soaking_style
       HAVING  inputQuantity > 0

       UNION

       SELECT  
       pl.production_log_id AS production_log_id,
       DATE(pl.date) AS createdAt,

       CASE 
           WHEN pl.rejection_from LIKE '%/%' AND pl.rejection_from RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.rejection_from, 1, LENGTH(pl.rejection_from) - LOCATE('-', REVERSE(pl.rejection_from)))
           ELSE pl.rejection_from 
       END AS rejectionFrom,

       CASE 
           WHEN pl.soakingout_product LIKE '%/%' AND pl.soakingout_product RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.soakingout_product, 1, LENGTH(pl.soakingout_product) - LOCATE('-', REVERSE(pl.soakingout_product)))
           ELSE pl.soakingout_product 
       END AS soakingOutProduct,

       CASE 
           WHEN pl.product LIKE '%/%' AND pl.product RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.product, 1, LENGTH(pl.product) - LOCATE('-', REVERSE(pl.product)))
           ELSE pl.product 
       END AS product,

       SUM(IF(pl.operation = 'SOAKING', pl.input_quantity, 0)) AS inputQuantity,
       SUM(IF(pl.operation = 'PACKING' AND pl.rejection_from IS NOT NULL AND pl.soakingout_product IS NULL, pl.actual_output_quantity, 0)) AS actualOutputQuantity

       FROM ${appSettings.production_db}.production_log pl
       LEFT JOIN ${appSettings.masters_db}.sku_codes skur ON skur.short_code = pl.rejection_from
       WHERE DATE(pl.date) = '${req.date}'
       AND pl.operation IN ('SOAKING', 'PACKING')
       AND process_type IN ('FRESHPRODUCITON','REPROCESS')
       AND pl.rejection_from IS NOT NULL

       GROUP BY skur.food_type_id,skur.value_addition_one_id,skur.value_addition_two_id,skur.value_addition_three_id,skur.value_addition_four_id,
       skur.value_addition_five_id,skur.soaking_style

       UNION

       SELECT  
       pl.production_log_id AS production_log_id,
       DATE(pl.date) AS createdAt,

       CASE 
           WHEN pl.rejection_from LIKE '%/%' AND pl.rejection_from RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.rejection_from, 1, LENGTH(pl.rejection_from) - LOCATE('-', REVERSE(pl.rejection_from)))
           ELSE pl.rejection_from 
       END AS rejectionFrom,

       CASE 
           WHEN pl.soakingout_product LIKE '%/%' AND pl.soakingout_product RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.soakingout_product, 1, LENGTH(pl.soakingout_product) - LOCATE('-', REVERSE(pl.soakingout_product)))
           ELSE pl.soakingout_product 
       END AS soakingOutProduct,

       CASE 
           WHEN pl.product LIKE '%/%' AND pl.product RLIKE '.*/[0-9]+$' THEN 
               SUBSTRING(pl.product, 1, LENGTH(pl.product) - LOCATE('-', REVERSE(pl.product)))
           ELSE pl.product 
       END AS product,

       SUM(IF(pl.operation = 'SOAKING', pl.input_quantity, 0)) AS inputQuantity,
       SUM(IF(pl.operation = 'PACKING' AND pl.rejection_from IS NULL AND pl.soakingout_product IS NOT NULL, pl.actual_output_quantity, 0)) AS actualOutputQuantity

       FROM ${appSettings.production_db}.production_log pl
       LEFT JOIN ${appSettings.masters_db}.sku_codes skus ON skus.short_code = pl.soakingout_product
       WHERE DATE(pl.date) = '${req.date}'
       AND pl.operation IN ('SOAKING', 'PACKING')
       AND process_type IN ('FRESHPRODUCITON','REPROCESS')
       AND pl.soakingout_product IS NOT NULL

       GROUP BY skus.food_type_id,skus.value_addition_one_id,skus.value_addition_two_id,skus.value_addition_three_id,skus.value_addition_four_id,
       skus.value_addition_five_id,skus.soaking_style`

        const fullData = await manager.query(query);

        const firstSet = [];
        const secondSet = [];
        const thirdSet = [];

        for (const row of fullData) {
            if (!row.rejectionFrom && !row.soakingOutProduct) {
                firstSet.push(row);
            } else if (row.rejectionFrom && !row.soakingOutProduct) {
                secondSet.push(row);
            } else if (!row.rejectionFrom && row.soakingOutProduct) {
                thirdSet.push(row);
            }
        }

    const finalResult = firstSet.map(row => {
    const productBase = row.product;

    const secondMatch = secondSet.find(r => r.rejectionFrom === productBase);
    const thirdMatch = thirdSet.find(r => r.soakingOutProduct === productBase);

    const secondQty = secondMatch ? Number(secondMatch.actualOutputQuantity) : 0;
    const thirdQty = thirdMatch ? Number(thirdMatch.actualOutputQuantity) : 0;

    return {
        ...row,
        actualOutputQuantity: (Number(row.actualOutputQuantity) + secondQty + thirdQty).toFixed(2)
    };
});

return new CommonResponse(true, 1, "Soaking Details Retrieved Successfully", finalResult);
    }

    async getShiftWiseDataForProductionReport(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');

        const lotCodeDataQuery = `
            SELECT 
                SUM(l.quantity) AS grnHonQuantity, 
                l.sample_yield AS sampleYield, 
                CASE 
                    WHEN l.lot_club_status = 1 THEN l.clubbed_main_lot 
                    ELSE l.lot_number 
                END AS lot_group
            FROM erpx_dev_production.lot_code_data l
            GROUP BY lot_group
        `;

        const lotCodeData = await manager.query(lotCodeDataQuery);

        const lotGroupMap = new Map();
        lotCodeData.forEach(row => {
            lotGroupMap.set(row.lot_group, row.grnHonQuantity);
        });

        const productionLogQuery = `
            SELECT 
                pl.shift, 
                pl.lot_number AS lotNumber, 
                pl.input_grade AS grnHonCount,
                SUM(IF(pl.operation = 'DEHEADING', pl.actual_output_quantity, 0)) AS actualOutputQuantity,
                SUM(IF(pl.operation = 'GRADING' AND pl.date = '${req.date}', pl.actual_output_quantity, 0)) AS quantity,
                l.sample_yield AS sampleYield
            FROM erpx_dev_production.production_log pl
            LEFT JOIN erpx_dev_production.lot_code_data l 
                ON l.lot_number = pl.lot_number AND l.count = pl.input_grade
            WHERE pl.operation IN ('DEHEADING', 'GRADING')
            GROUP BY pl.lot_number, pl.input_grade
            HAVING quantity > 0
        `;

        const productionLogData = await manager.query(productionLogQuery);

        const result = productionLogData.map(row => ({
            ...row,
            grnHonQuantity: lotGroupMap.get(row.lotNumber) || 0
        }));

        if (result.length > 0) {
            return new CommonResponse(true, 1, "Shift Wise Data Retrieved Successfully", result);
        } else {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
    }



    async getTotalProductionForDashboard(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');
    
const query = `
    SELECT r.reporting_log_id, DATE(r.reporting_date) AS reportingDate, r.variant_id, 
           r.reported_cases AS cases, r.loose_pouches AS loosePouches, r.pack_style_id, 
           sku.short_code, pm.packing_method_name, pm.pouches_per_row AS pouchWeight, 
           uom.uom_name AS uomName, pm.gross_weight AS grossWeight,vfi.code AS valueFiveCode
    FROM erpx_dev_warehouse.reporting r
    LEFT JOIN erpx_dev_masters.sku_codes sku ON sku.sku_code_id = r.variant_id
    LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = r.pack_style_id
    LEFT JOIN erpx_dev_masters.uoms uom ON uom.uom_id = pm.uom_id
    LEFT JOIN erpx_dev_masters.value_addition_five_types vfi ON vfi.value_addition_five_id = sku.value_addition_five_id
    WHERE r.reporting_log_id > 0 
      AND DATE(r.reporting_date) = '${req.date}' 
      AND r.transaction_type IN ('reprocessing', 'rm');
`;

    
        const data = await manager.query(query);
        if (!Array.isArray(data) || data.length === 0) {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
    
        let totalSlabs = 0;
        let totalKgs = 0;
        let totalGrossWeight = 0;
    
        const processedData = data.map((row: any) => {
            let conversionFactor = 1;
            if (row.uomName) {
                if (row.uomName.toLowerCase().includes('lb')) conversionFactor = 0.454;
                else if (row.uomName.toLowerCase().includes('oz')) conversionFactor = 0.0283495;
                else if (row.uomName.toLowerCase().includes('gm')) conversionFactor = 0.001;
            }
    
            const match = row.packing_method_name ? row.packing_method_name.match(/(\d+)[X](\d+(\.\d+)?)/) : null;
            const pouchWeight = Number(row.pouchWeight) * conversionFactor;
            const grossWeight = Number(row.grossWeight);
            const pouchesPerCase = match ? Number(match[1]) : 1;
    
            const slabsFromCases = Number(row.cases) * pouchesPerCase;
            const slabsFromLoosePouches = Number(row.loosePouches) || 0;
            const totalSlabsForRow = slabsFromCases + slabsFromLoosePouches;
    
            const totalKgsForRow = totalSlabsForRow * pouchWeight;
            const totalGrossKgsForRow = totalSlabsForRow * grossWeight;
    
            totalSlabs += totalSlabsForRow;
            totalKgs += totalKgsForRow;
            totalGrossWeight += totalGrossKgsForRow;
    
    
            let convertedShortCode;
            if (!row.valueFiveCode || row.valueFiveCode === "GII") {
                // Split short_code when valueFiveCode is null or "GII"
                convertedShortCode = `${row.short_code?.split('-')?.slice(0, 2)?.join('-')} ${Number(row.pouchWeight)} ${row.uomName}`;
            } else {
                // Keep short_code unchanged when valueFiveCode is not null and not "GII"
                convertedShortCode = `${row.short_code}${" "} ${Number(row.pouchWeight)} ${row.uomName}`;
            }
        
            return {
                slabs: totalSlabsForRow,
                noOfKgs: Number(totalKgsForRow.toFixed(3)),
                convertedShortCode,
                grossWeight,
                grossWeightPerKg: Number(totalGrossKgsForRow.toFixed(3)),
            };
        });
    
        const aggregatedData = Object.values(processedData.reduce((acc: any, row: any) => {
            if (acc[row.convertedShortCode]) {
                acc[row.convertedShortCode].slabs += row.slabs;
                acc[row.convertedShortCode].noOfKgs += row.noOfKgs;
                acc[row.convertedShortCode].grossWeightPerKg += row.grossWeightPerKg;
            } else {
                acc[row.convertedShortCode] = { ...row };
            }
            return acc;
        }, {}));
    
        const finalData = aggregatedData.map((row: any) => ({
            ...row,
            noOfKgs: Number(row.noOfKgs.toFixed(3)),
            grossWeightPerKg: Number(row.grossWeightPerKg.toFixed(3)),
        }));
    
    
        return new CommonResponse(true, 1, "Production Data Retrieved Successfully", {
            data: finalData,
            totalSlabs,
            totalKgs: Number(totalKgs.toFixed(3)),
            totalGrossWeight: Number(totalGrossWeight.toFixed(3)),
        });
    }
    




    async getValueAdditionQuantitiesForProduction(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');
        
        const query = `
            SELECT vfi.code AS valueFiveCode, r.reporting_date, r.reported_cases AS cases, r.loose_pouches AS loosePouches,
                   pm.packing_method_name, pm.pouches_per_row AS pouchWeight, pm.gross_weight AS grossWeight, uom.uom_name AS uomName
            FROM erpx_dev_warehouse.reporting r
            LEFT JOIN erpx_dev_masters.sku_codes sku ON sku.sku_code_id = r.variant_id
            LEFT JOIN erpx_dev_masters.value_addition_five_types vfi ON vfi.value_addition_five_id = sku.value_addition_five_id
            LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN erpx_dev_masters.uoms uom ON uom.uom_id = pm.uom_id
            WHERE vfi.code IN ('DC', 'GII', 'BKN') AND DATE(r.reporting_date) = '${req.date}' AND r.transaction_type IN ('reprocessing', 'rm')
        `;
        
        const rawData = await manager.query(query);
        
        if (!rawData || rawData.length === 0) {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
        
        let totalDC = 0;
        let totalGII = 0;
        let totalBKN = 0;
        
        rawData.forEach((row: any) => {
            let conversionFactor = 1;
            if (row.uomName) {
                if (row.uomName.toLowerCase().includes('lb')) conversionFactor = 0.454;
                else if (row.uomName.toLowerCase().includes('oz')) conversionFactor = 0.0283495;
                else if (row.uomName.toLowerCase().includes('gm')) conversionFactor = 0.001;
            }
            
            const match = row.packing_method_name ? row.packing_method_name.match(/(\d+)[X](\d+(\.\d+)?)/) : null;
            const pouchWeight = Number(row.pouchWeight) * conversionFactor;
            const pouchesPerCase = match ? Number(match[1]) : 1;
            
            const slabsFromCases = Number(row.cases) * pouchesPerCase;
            const slabsFromLoosePouches = Number(row.loosePouches) || 0;
            const totalSlabsForRow = slabsFromCases + slabsFromLoosePouches;
            
            const noOfKgs = totalSlabsForRow * pouchWeight;
            
            if (row.valueFiveCode === 'DC') {
                totalDC += noOfKgs;
            } else if (row.valueFiveCode === 'GII') {
                totalGII += noOfKgs;
            } else if (row.valueFiveCode === 'BKN') {
                totalBKN += noOfKgs;
            }
        });
        
        return new CommonResponse(true, 1, "Data Retrieved Successfully", {
            totalDC: Number(totalDC.toFixed(3)),
            totalGII: Number(totalGII.toFixed(3)),
            totalBKN: Number(totalBKN.toFixed(3))
        });
    }
    
    



    async getValueAdditionFourForProduction(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');
        
        const query = `
            SELECT  vf.code AS valueFourCode, r.reporting_date, r.reported_cases AS cases, r.loose_pouches AS loosePouches, 
                    pm.packing_method_name, pm.pouches_per_row AS pouchWeight, pm.gross_weight AS grossWeight, uom.uom_name AS uomName
            FROM  erpx_dev_warehouse.reporting r
            LEFT JOIN  erpx_dev_masters.sku_codes sku ON sku.sku_code_id = r.variant_id
            LEFT JOIN  erpx_dev_masters.value_addition_four_types vf ON vf.value_addition_four_id = sku.value_addition_four_id
            LEFT JOIN  erpx_dev_masters.packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN  erpx_dev_masters.uoms uom ON uom.uom_id = pm.uom_id
            WHERE  vf.code IN ('BLK', 'IQF')  AND DATE(r.reporting_date) = '${req.date}'  AND r.transaction_type IN ('reprocessing', 'rm')
        `;
        
        const rawData = await manager.query(query);
        
        if (!rawData || rawData.length === 0) {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
        
        let totalBlk = 0;
        let totalIqf = 0;
        
        rawData.forEach((row: any) => {
            let conversionFactor = 1;
            if (row.uomName) {
                if (row.uomName.toLowerCase().includes('lb')) conversionFactor = 0.454;
                else if (row.uomName.toLowerCase().includes('oz')) conversionFactor = 0.0283495;
                else if (row.uomName.toLowerCase().includes('gm')) conversionFactor = 0.001;
            }
            
            const match = row.packing_method_name ? row.packing_method_name.match(/(\d+)[X](\d+(\.\d+)?)/) : null;
            const pouchWeight = Number(row.pouchWeight) * conversionFactor;
            const pouchesPerCase = match ? Number(match[1]) : 1;
            
            const slabsFromCases = Number(row.cases) * pouchesPerCase;
            const slabsFromLoosePouches = Number(row.loosePouches) || 0;
            const totalSlabsForRow = slabsFromCases + slabsFromLoosePouches;
            
            const noOfKgs = totalSlabsForRow * pouchWeight;
            
            if (row.valueFourCode === 'BLK') {
                totalBlk += noOfKgs;
            } else if (row.valueFourCode === 'IQF') {
                totalIqf += noOfKgs;
            }
        });
        
        return new CommonResponse(true, 1, "Data Retrieved Successfully", {
            totalBlk: Number(totalBlk.toFixed(3)),
            totalIqf: Number(totalIqf.toFixed(3))
        });
    }
    


    async getBillInfoByBillNumber(req?: BillNumberRequest): Promise<CommonResponse> {
        console.log(req, "101010")
        const manager = getManager();
        try {
            // req.billNumber = 'Bil-8/8'
            let totalsQry = `select sum(amount) as amount,IF(operation = '${OperationTypeEnum.VALUE_ADDITION}',sum(input_quantity),sum(actual_output_quantity)) as opQty,sum(actual_output_quantity) as meatBasedOpQty from production_log where production_log_id > 0`;
            if (req.billNumber) {

                totalsQry = totalsQry + ` and bill_no = '${req.billNumber}'`
                // totalsQry = totalsQry+` AND CONCAT(bill_no, '-', DATE_FORMAT(date, '%Y-%m')) = '${req.billNumber}'`
            }
            if (req.contractorId) {
                totalsQry = totalsQry + ` and contractor_id = '${req.contractorId}'`
            }

            if (req.operation) {
                totalsQry = totalsQry + ` and operation = '${req.operation}'`
            }

            if (req.fromDate && req.toDate) {
                totalsQry = totalsQry + ` AND date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
            }

            const billTotalsInfo = await manager.query(totalsQry)
            let billInfoQry = `select production_log_id productionLogId,pl.product,pl.operation,w.workstation as workstationName,pl.input_grade as HONcount,pl.input_quantity as ipQty,IF(pl.operation = '${OperationTypeEnum.VALUE_ADDITION}',pl.input_quantity,pl.actual_output_quantity) as opQty,pl.sub_lot_number as subLotNumber,pl.lot_number as lotNumber,pl.prev_operation as prevOPeration,pl.bill_no as billNo,date,shift,reporting_type as reportingType,c.contractor_name as contractorName,lc.quantity as grnQty,unit_price as unitPrice,amount as amount,pl.contractor_id as contractorId,pl.product,pri.physical_quantity as quantity,pl.operation,pl.actual_output_quantity as outputQty,pl.no_of_persons as noOfWorkers,pl.peeling_price_based_on as peelingPriceBasedOn from ${appSettings.production_db}.production_log pl left join ${appSettings.production_db}.workstations w on w.workstation_id = pl.workstation left join ${appSettings.hrms_db}.contractor c on c.contractor_id = pl.contractor_id left join ${appSettings.production_db}.lot_code_data lc on lc.lot_number= pl.lot_number and lc.count = pl.input_grade 
            left join ${appSettings.production_db} .production_inventory pri ON pri.lot_number = pl.lot_number AND pri.operation = '${OperationTypeEnum.GRN}'
            where pl.production_log_id > 0`;
            if (req.billNumber) {
                billInfoQry = billInfoQry + ` and pl.bill_no = '${req.billNumber}'`

                // billInfoQry = billInfoQry+` AND CONCAT(pl.bill_no, '-', DATE_FORMAT(pl.date, '%Y-%m')) = '${req.billNumber}'`
            }
            if (req.contractorId) {
                console.log("conId")
                billInfoQry = billInfoQry + ` and pl.contractor_id = '${req.contractorId}'`
            }

            if (req.operation) {
                billInfoQry = billInfoQry + ` and pl.operation = '${req.operation}'`
            }


            if (req.fromDate && req.toDate) {
                billInfoQry += ` AND pl.date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
            }
            


            billInfoQry += ` GROUP BY production_log_id ORDER BY pl.lot_number ASC`;

            const billInfo = await manager.query(billInfoQry)
            if (billInfo.length > 0) {
                return new CommonResponse(true, 1, 'data retreived', billInfo, billTotalsInfo);
            } else {
                return new CommonResponse(false, 1, 'No data', undefined);
            }
        } catch (err) {
            return new CommonResponse(false, 1, 'Something Went Wrong', err);
        }
    }


    async getWorkersInfoByBillNumber(req: BillNumberRequest): Promise<CommonResponse> {
        const manager = getManager()
        try {
            const billInfoQry = `SELECT worker_code AS workerCode , worker_name AS workerName, village, pw.transportation , c.contractor_name AS contractorName,pw.transport_charges AS transportCost,
            bill_no AS billNo
            FROM ${appSettings.production_db} .production_workers pw
            LEFT JOIN ${appSettings.masters_db} .workers w ON w.worker_id =  pw.emp_id
            LEFT JOIN ${appSettings.hrms_db} .contractor c ON c.contractor_id = pw.contractor_id where pw.bill_no = '${req.billNumber}'`;
            const billInfo = await manager.query(billInfoQry)
            if (billInfo.length > 0) {
                return new CommonResponse(true, 1, 'data retreived', billInfo);
            } else {
                return new CommonResponse(false, 1, 'No data', undefined);
            }

        } catch (err) {
            return new CommonResponse(false, 1, 'Something Went Wrong', err);
        }
    }

    async getDistinctBillNumber(req?: BillNumberRequest): Promise<CommonResponse> {
        const manager = getManager()
        try {
            const query = `SELECT DISTINCT bill_no FROM ${appSettings.production_db}.production_log
            where operation = '${req.operation}' AND bill_no IS NOT NULL`;
            const billNo = await manager.query(query)
            if (billNo.length > 0) {
                return new CommonResponse(true, 1, 'data retreived', billNo);
            } else {
                return new CommonResponse(false, 1, 'No data', []);
            }
        } catch (err) {
            return new CommonResponse(false, 1, 'Something Went Wrong', err);
        }
    }


    async getDistinctContractorName(req?: BillNumberRequest): Promise<CommonResponse> {
        console.log(req, "contr")
        const manager = getManager()
        try {
            const query = `SELECT DISTINCT pl.contractor_id AS contractorId , c.contractor_name AS contractorName from  ${appSettings.production_db}.production_log pl
            LEFT JOIN ${appSettings.hrms_db}.contractor c ON c.contractor_id = pl.contractor_id
            WHERE c.contractor_name IS NOT NULL AND pl.operation = '${req.operation}' `;
            const contractorName = await manager.query(query)
            if (contractorName.length > 0) {
                return new CommonResponse(true, 1, 'data retreived', contractorName);
            } else {
                return new CommonResponse(false, 1, 'No data', []);
            }
        } catch (err) {
            return new CommonResponse(false, 1, 'Something Went Wrong', err);
        }
    }


    // async getContractorwiseBillGeneration(req?: BillGenerationReportRequest): Promise<CommonResponse> {
    //     const startOfMonth = new Date(req.year, req.month - 1, 1); // 1st day of the month
    //     const firstFortnightEnd = new Date(req.year, req.month - 1, 15); // 15th day of the month
    //     const secondFortnightStart = new Date(req.year, req.month - 1, 16); // 16th day of the month
    //     const endOfMonth = new Date(req.year, req.month, 0); // last day of the month

    //     // Format dates using moment.js for SQL compatibility
    //     const firstDate = moment(startOfMonth).format("YYYY-MM-DD");
    //     const fifteenDate = moment(firstFortnightEnd).format("YYYY-MM-DD");
    //     const sixteenDate = moment(secondFortnightStart).format("YYYY-MM-DD");
    //     const endOfMon = moment(endOfMonth).format("YYYY-MM-DD");

    //     const manager = getManager(); // Database manager instance for running SQL queries

    //     let firstFortNightData = [];
    //     let secondFortNightData = [];
    //     let peelingfirstData = [];
    //     let peelingfinalData = [];
    //     let peelingCuttingfirstData = [];
    //     let peelingCuttingfinalData = [];



    //     let qwertyData = [];
    //     let qwertyFinalData = [];

    //     let firstPeelingCuttingData = []
    //     let finalPeelingCuttingData = []
    //     let firstOtherData = []
    //     let finalOtherData = []



    //     let firstFortnightPeeling: FirstFortnightPeeling[] = [];
    //     let finalFortnightPeeling: FinalFortnightPeeling[] = [];
    //     let firstPeelingCuttingModel: FirstPeelingCuttingModel[] = []
    //     let finalPeelingCuttingModel: FinalPeelingCuttingModel[] = []
    //     let othersModel: OtherModel[] = []





    //     try {
    //         // Define SQL queries
    //         const firstFortNightQuery = `SELECT dr.contractor_name, dr.count, dr.rate, SUM(pl.amount) AS totalAmount, SUM(pl.actual_output_quantity) AS totalQty
    //             FROM erpx_dev_masters.deheading_rates dr
    //             JOIN erpx_dev_production.production_log pl ON dr.contractor_id = pl.contractor_id
    //             WHERE pl.operation = 'deheading'
    //             AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
    //             AND pl.contractor_id = ${req.contractorId}
    //             AND pl.input_grade BETWEEN dr.min_count AND dr.max_count
    //             GROUP BY dr.contractor_name, dr.count`;

    //         const secondFortNightQuery = `SELECT dr.contractor_name, dr.count, dr.rate, SUM(pl.amount) AS totalAmount, SUM(pl.actual_output_quantity) AS totalQty
    //             FROM erpx_dev_masters.deheading_rates dr
    //             JOIN erpx_dev_production.production_log pl ON dr.contractor_id = pl.contractor_id
    //             WHERE pl.operation = 'deheading'
    //             AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
    //             AND pl.contractor_id = ${req.contractorId}
    //             AND pl.input_grade BETWEEN dr.min_count AND dr.max_count
    //             GROUP BY dr.contractor_name, dr.count`;

    //         const peelingFirst = `SELECT DISTINCT scope_of_work FROM erpx_dev_production.production_log
    //             WHERE operation = 'VALUE ADDITION' AND date BETWEEN '${firstDate}' AND '${fifteenDate}' AND contractor_id = ${req.contractorId}`;

    //         const peelingFinal = `SELECT DISTINCT scope_of_work FROM erpx_dev_production.production_log
    //             WHERE operation = 'VALUE ADDITION' AND date BETWEEN '${sixteenDate}' AND '${endOfMon}' AND contractor_id = ${req.contractorId}`;


    //         const firstPeelingCutting = `SELECT operation,bill_no,scope_of_work FROM erpx_dev_production.production_log
    //        WHERE bill_no IN (SELECT bill_no FROM erpx_dev_production.production_log WHERE operation IN ('VALUE ADDITION', 'DEHEADING') AND date BETWEEN '${firstDate}' AND '${fifteenDate}'
    //        AND contractor_id = ${req.contractorId} GROUP BY bill_no HAVING COUNT(DISTINCT operation) = 2) AND date BETWEEN '${firstDate}' AND '${fifteenDate}'
    //        AND contractor_id = ${req.contractorId} AND operation ='VALUE ADDITION'`

    //         const finalPeelingCutting = `SELECT operation,bill_no,scope_of_work FROM erpx_dev_production.production_log
    //       WHERE bill_no IN (SELECT bill_no FROM erpx_dev_production.production_log WHERE operation IN ('VALUE ADDITION', 'DEHEADING') AND date BETWEEN '${sixteenDate}' AND '${endOfMon}'
    //       AND contractor_id = ${req.contractorId} GROUP BY bill_no HAVING COUNT(DISTINCT operation) = 2) AND date BETWEEN '${sixteenDate}' AND '${endOfMon}'
    //       AND contractor_id = ${req.contractorId} AND operation ='VALUE ADDITION'`

    //       const firstOther = `SELECT SUM(pw.transport_charges) AS amount,SUM(p.no_of_persons) AS Qty  FROM erpx_dev_production.production_log p
    //       LEFT JOIN erpx_dev_production.production_workers pw ON pw.production_log_id = p.production_log_id
    //       WHERE p.contractor_id = ${req.contractorId} AND  p.date BETWEEN '${firstDate}' AND '${fifteenDate}' AND transportation = "AUTO"
    //       GROUP BY p.contractor_id`

    //       const finalOther = `SELECT SUM(pw.transport_charges) AS amount,SUM(p.no_of_persons) AS Qty  FROM erpx_dev_production.production_log p
    //       LEFT JOIN erpx_dev_production.production_workers pw ON pw.production_log_id = p.production_log_id
    //       WHERE p.contractor_id = ${req.contractorId} AND  p.date BETWEEN '${sixteenDate}' AND '${endOfMon}' AND transportation = "AUTO"
    //       GROUP BY p.contractor_id`

    //         // Fetch `peelingfirstData` only for "First Fortnight" bill type
    //         if (req.billType === "First Fortnight") {
    //             firstFortNightData = await manager.query(firstFortNightQuery);
    //             peelingfirstData = await manager.query(peelingFirst);
    //             peelingCuttingfirstData = await manager.query(firstPeelingCutting);
    //             firstOtherData = await manager.query(firstOther)



    //             for (const record of peelingfirstData) {
    //                 const qwerty = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, dr.rate_per_kg AS rate
    //                     FROM erpx_dev_masters.deheading_peeling_chart dr
    //                     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
    //                     WHERE pl.operation = 'VALUE ADDITION'
    //                     AND pl.scope_of_work = '${record.scope_of_work}'
    //                     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade`;
    //                 const result = await manager.query(qwerty);
    //                 qwertyData.push(...result);
    //             }

    //             const scopeMap: { [key: string]: ScopeData[] } = {};
    //             for (const val of qwertyData) {
    //                 if (!scopeMap[val.scope_of_work]) {
    //                     scopeMap[val.scope_of_work] = [];
    //                 }
    //                 scopeMap[val.scope_of_work].push(new ScopeData(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work));
    //             }

    //             for (const [scope, data] of Object.entries(scopeMap)) {
    //                 firstFortnightPeeling.push(new FirstFortnightPeeling(scope, data));
    //             }

    //             for (const record of peelingCuttingfirstData) {
    //                 const qwerty = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, dr.rate_per_kg AS rate
    //                     FROM erpx_dev_masters.deheading_peeling_chart dr
    //                     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
    //                     WHERE pl.operation = 'VALUE ADDITION'
    //                     AND pl.scope_of_work = '${record.scope_of_work}'
    //                     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade`;
    //                 const result = await manager.query(qwerty);
    //                 firstPeelingCuttingData.push(...result);

    //             }

    //             for (const val of firstPeelingCuttingData) {
    //                 firstPeelingCuttingModel.push(new FirstPeelingCuttingModel(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work))
    //             }


    //               const firstForntOther = new FirstOther(firstOtherData[0]?.amount,firstOtherData[0]?.Qty)
    //               const finalForntOther = new  FinalOther("0","0")
    //               othersModel.push(new OtherModel(firstForntOther,finalForntOther) )





    //         } else if (req.billType === "Final Fortnight") {
    //             // Fetch `peelingfirstData` and `peelingfinalData` for "Final Fortnight" bill type
    //             firstFortNightData = await manager.query(firstFortNightQuery);
    //             secondFortNightData = await manager.query(secondFortNightQuery);
    //             peelingCuttingfirstData = await manager.query(firstPeelingCutting);
    //             peelingCuttingfinalData = await manager.query(finalPeelingCutting);
    //             firstOtherData = await manager.query(firstOther)
    //             finalOtherData = await manager.query(finalOther)







    //             peelingfirstData = await manager.query(peelingFirst);
    //             peelingfinalData = await manager.query(peelingFinal);

    //             for (const record of peelingfirstData) {
    //                 const qwerty = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, dr.rate_per_kg AS rate
    //                     FROM erpx_dev_masters.deheading_peeling_chart dr
    //                     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
    //                     WHERE pl.operation = 'VALUE ADDITION'
    //                     AND pl.scope_of_work = '${record.scope_of_work}'
    //                     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade`;
    //                 const result = await manager.query(qwerty);
    //                 qwertyData.push(...result);
    //             }

    //             const scopeMap: { [key: string]: ScopeData[] } = {};
    //             for (const val of qwertyData) {
    //                 if (!scopeMap[val.scope_of_work]) {
    //                     scopeMap[val.scope_of_work] = [];
    //                 }
    //                 scopeMap[val.scope_of_work].push(new ScopeData(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work));
    //             }

    //             for (const [scope, data] of Object.entries(scopeMap)) {
    //                 firstFortnightPeeling.push(new FirstFortnightPeeling(scope, data));
    //             }

    //             for (const record of peelingfinalData) {
    //                 const qwertyFinal = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, dr.rate_per_kg AS rate
    //                     FROM erpx_dev_masters.deheading_peeling_chart dr
    //                     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
    //                     WHERE pl.operation = 'VALUE ADDITION'
    //                     AND pl.scope_of_work = '${record.scope_of_work}'
    //                     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade`;
    //                 const result = await manager.query(qwertyFinal);
    //                 qwertyFinalData.push(...result);
    //             }

    //             const scopeMaps: { [key: string]: ScopeData[] } = {};
    //             for (const val of qwertyFinalData) {
    //                 if (!scopeMaps[val.scope_of_work]) {
    //                     scopeMaps[val.scope_of_work] = [];
    //                 }
    //                 scopeMaps[val.scope_of_work].push(new ScopeData(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work));
    //             }

    //             for (const [scope, data] of Object.entries(scopeMaps)) {
    //                 finalFortnightPeeling.push(new FinalFortnightPeeling(scope, data));
    //             }


    //             for (const record of peelingCuttingfirstData) {
    //                 const qwerty = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, dr.rate_per_kg AS rate
    //                     FROM erpx_dev_masters.deheading_peeling_chart dr
    //                     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
    //                     WHERE pl.operation = 'VALUE ADDITION'
    //                     AND pl.scope_of_work = '${record.scope_of_work}'
    //                     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade`;
    //                 const result = await manager.query(qwerty);
    //                 firstPeelingCuttingData.push(...result);

    //             }

    //             for (const val of firstPeelingCuttingData) {
    //                 firstPeelingCuttingModel.push(new FirstPeelingCuttingModel(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work))
    //             }

    //             for (const record of peelingCuttingfinalData) {
    //                 const qwerty = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, dr.rate_per_kg AS rate
    //                     FROM erpx_dev_masters.deheading_peeling_chart dr
    //                     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
    //                     WHERE pl.operation = 'VALUE ADDITION'
    //                     AND pl.scope_of_work = '${record.scope_of_work}'
    //                     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade`;
    //                 const result = await manager.query(qwerty);
    //                 finalPeelingCuttingData.push(...result);

    //             }

    //             for (const val of finalPeelingCuttingData) {
    //                 finalPeelingCuttingModel.push(new FinalPeelingCuttingModel(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work))
    //             }


    //             const firstForntOther = new FirstOther(firstOtherData[0]?.amount,firstOtherData[0]?.Qty)
    //             const finalForntOther = new  FinalOther(finalOtherData[0]?.amount,finalOtherData[0]?.Qty)
    //             othersModel.push(new OtherModel(firstForntOther,finalForntOther) )



    //         }

    //         if (firstFortNightData.length > 0 || secondFortNightData.length > 0 || qwertyData.length > 0) {
    //             let firstFortnightDeheading: FirstFortNightDeheading[] = [];
    //             let finalFortnightDeheading: FinalFortNightDeheading[] = [];

    //             for (const val of firstFortNightData) {
    //                 firstFortnightDeheading.push(new FirstFortNightDeheading(val.count, val.rate, val.totalAmount, val.totalQty));
    //             }

    //             if (req.billType === "Final Fortnight") {
    //                 for (const val of secondFortNightData) {
    //                     finalFortnightDeheading.push(new FinalFortNightDeheading(val.count, val.rate, val.totalAmount, val.totalQty));
    //                 }
    //             }

    //             const contractorName = firstFortNightData.length > 0 ? firstFortNightData[0].contractor_name : secondFortNightData[0]?.contractor_name;

    //             const response = new BillGenerationModel(
    //                 contractorName,
    //                 firstFortnightDeheading,
    //                 finalFortnightDeheading,
    //                 firstFortnightPeeling,
    //                 finalFortnightPeeling,
    //                 firstPeelingCuttingData,
    //                 finalPeelingCuttingModel,
    //                 othersModel
    //             );

    //             return new CommonResponse(true, 1, "Data retrieved", response);
    //         } else {
    //             return new CommonResponse(false, 0, "No data", []);
    //         }
    //     } catch (err) {
    //         console.error("Error retrieving contractor-wise bill generation data:", err);
    //         return new CommonResponse(false, 1, "Something went wrong", err);
    //     }
    // }

    async getContractorwiseBillGeneration(req?: BillGenerationReportRequest): Promise<CommonResponse> {
        console.log(req, "pollop")
        const startOfMonth = new Date(req.year, req.month - 1, 1); // 1st day of the month
        const firstFortnightEnd = new Date(req.year, req.month - 1, 15); // 15th day of the month
        const secondFortnightStart = new Date(req.year, req.month - 1, 16); // 16th day of the month
        const endOfMonth = new Date(req.year, req.month, 0); // last day of the month

        // Format dates using moment.js for SQL compatibility
        const firstDate = moment(startOfMonth).format("YYYY-MM-DD");
        const fifteenDate = moment(firstFortnightEnd).format("YYYY-MM-DD");
        const sixteenDate = moment(secondFortnightStart).format("YYYY-MM-DD");
        const endOfMon = moment(endOfMonth).format("YYYY-MM-DD");

        const manager = getManager(); // Database manager instance for running SQL queries

        let firstFortNightData = [];
        let secondFortNightData = [];
        let peelingfirstData = [];
        let peelingfinalData = [];
        let peelingCuttingfirstData = [];
        let peelingCuttingfinalData = [];



        let qwertyData = [];
        let qwertyFinalData = [];

        let firstPeelingCuttingData = []
        let finalPeelingCuttingData = []
        let firstOtherData = []
        let finalOtherData = []

        let firstOtherAutoBusData = []
        let finalOtherAutoBusData = []



        let firstFortnightPeeling: FirstFortnightPeeling[] = [];
        let finalFortnightPeeling: FinalFortnightPeeling[] = [];
        let firstPeelingCuttingModel: FirstPeelingCuttingModel[] = []
        let finalPeelingCuttingModel: FinalPeelingCuttingModel[] = []
        let othersModel: OtherModel[] = []

        let firstFortnightDeheading: FirstFortNightDeheading[] = [];
        let finalFortnightDeheading: FinalFortNightDeheading[] = [];





        try {
            // Define SQL queries
            // const firstFortNightQuery = `SELECT dr.contractor_name, dr.count, dr.rate, SUM(pl.amount) AS totalAmount, SUM(pl.actual_output_quantity) AS totalQty
            //     FROM erpx_dev_masters.deheading_rates dr
            //     JOIN erpx_dev_production.production_log pl ON dr.contractor_id = pl.contractor_id
            //     WHERE pl.operation = 'deheading'
            //     AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
            //     AND pl.contractor_id = ${req.contractorId}
            //     AND pl.input_grade BETWEEN dr.min_count AND dr.max_count
            //     GROUP BY dr.contractor_name, dr.count`;

            const firstFortNightQuery = `SELECT dr.contractor_name, dr.count, dr.rate, SUM(pl.amount) AS totalAmount, SUM(pl.actual_output_quantity) AS totalQty
            FROM erpx_dev_masters.deheading_rates dr
            JOIN erpx_dev_production.production_log pl ON dr.contractor_id = pl.contractor_id
            WHERE pl.operation = 'DEHEADING'
            AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
            AND pl.contractor_id = ${req.contractorId}
           AND (
        (FLOOR(pl.input_grade) BETWEEN dr.min_count AND dr.max_count)
        OR 
        (dr.count = 'Any') 
    )
            GROUP BY dr.contractor_name, dr.count`;

            // const secondFortNightQuery = `SELECT dr.contractor_name, dr.count, dr.rate, SUM(pl.amount) AS totalAmount, SUM(pl.actual_output_quantity) AS totalQty
            //     FROM erpx_dev_masters.deheading_rates dr
            //     JOIN erpx_dev_production.production_log pl ON dr.contractor_id = pl.contractor_id
            //     WHERE pl.operation = 'deheading'
            //     AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
            //     AND pl.contractor_id = ${req.contractorId}
            //     AND pl.input_grade BETWEEN dr.min_count AND dr.max_count
            //     GROUP BY dr.contractor_name, dr.count`;

            const secondFortNightQuery = `SELECT dr.contractor_name, dr.count, dr.rate, SUM(pl.amount) AS totalAmount, SUM(pl.actual_output_quantity) AS totalQty
            FROM erpx_dev_masters.deheading_rates dr
            JOIN erpx_dev_production.production_log pl ON dr.contractor_id = pl.contractor_id
            WHERE pl.operation = 'DEHEADING'
            AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
            AND pl.contractor_id = ${req.contractorId}
             AND (
         (FLOOR(pl.input_grade) BETWEEN dr.min_count AND dr.max_count) 
        OR 
        (dr.count = 'Any') 
    )
            GROUP BY dr.contractor_name, dr.count`;

            const peelingFirst = `SELECT DISTINCT scope_of_work FROM erpx_dev_production.production_log
                WHERE operation = 'VALUE ADDITION' AND date BETWEEN '${firstDate}' AND '${fifteenDate}' AND contractor_id = ${req.contractorId}`;

            const peelingFinal = `SELECT DISTINCT scope_of_work FROM erpx_dev_production.production_log
                WHERE operation = 'VALUE ADDITION' AND date BETWEEN '${sixteenDate}' AND '${endOfMon}' AND contractor_id = ${req.contractorId}`;


            const firstPeelingCutting = `SELECT operation,bill_no,scope_of_work FROM erpx_dev_production.production_log
           WHERE bill_no IN (SELECT bill_no FROM erpx_dev_production.production_log WHERE operation IN ('VALUE ADDITION', 'DEHEADING') AND date BETWEEN '${firstDate}' AND '${fifteenDate}'
           AND contractor_id = ${req.contractorId} GROUP BY bill_no HAVING COUNT(DISTINCT operation) = 2) AND date BETWEEN '${firstDate}' AND '${fifteenDate}'
           AND contractor_id = ${req.contractorId} AND operation ='VALUE ADDITION' GROUP BY bill_no,scope_of_work`

            const finalPeelingCutting = `SELECT operation,bill_no,scope_of_work FROM erpx_dev_production.production_log
          WHERE bill_no IN (SELECT bill_no FROM erpx_dev_production.production_log WHERE operation IN ('VALUE ADDITION', 'DEHEADING') AND date BETWEEN '${sixteenDate}' AND '${endOfMon}'
          AND contractor_id = ${req.contractorId} GROUP BY bill_no HAVING COUNT(DISTINCT operation) = 2) AND date BETWEEN '${sixteenDate}' AND '${endOfMon}'
          AND contractor_id = ${req.contractorId} AND operation ='VALUE ADDITION' GROUP BY bill_no,scope_of_work`

            //     const firstOther = `SELECT SUM(pw.transport_charges) AS amount,SUM(p.no_of_persons) AS Qty  FROM erpx_dev_production.production_log p
            //   LEFT JOIN erpx_dev_production.production_workers pw ON pw.production_log_id = p.production_log_id
            //   WHERE p.contractor_id = ${req.contractorId} AND  p.date BETWEEN '${firstDate}' AND '${fifteenDate}' AND transportation = "AUTO"
            //   GROUP BY p.contractor_id`

            const firstOther = `SELECT 
    SUM(t.no_of_worker) AS Qty,
    SUM(t.amount) AS amount
FROM (
     SELECT COUNT(DISTINCT pw.emp_name) AS no_of_worker, vtc.transport_cost AS cost ,(vtc.transport_cost * COUNT(DISTINCT pw.emp_name)) AS amount FROM production_workers pw
        LEFT JOIN erpx_dev_production.production_log pl ON pl.production_log_id = pw.production_log_id
        LEFT JOIN erpx_dev_masters.village_transport_cost vtc ON vtc.village_name = pw.village
        WHERE pw.contractor_id = ${req.contractorId} AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}' AND pw.transportation = 'Auto'
        GROUP BY vtc.village_name, pl.date
) t`

            const firstOtherautoBus = `SELECT SUM(t.no_of_persons) AS Qty
        FROM (
            SELECT DISTINCT p.bill_no, p.no_of_persons
            FROM production_log p
            LEFT JOIN erpx_dev_production.production_workers pw ON pw.production_log_id = p.production_log_id
            WHERE p.contractor_id =  ${req.contractorId} AND p.date BETWEEN '${firstDate}' AND '${fifteenDate}' AND transportation  IN ('Auto','Bus')
        ) t`

            const finalOther = `SELECT 
    SUM(t.no_of_worker) AS Qty,
    SUM(t.amount) AS amount
FROM (
     SELECT COUNT(DISTINCT pw.emp_name) AS no_of_worker, vtc.transport_cost AS cost ,(vtc.transport_cost * COUNT(DISTINCT pw.emp_name)) AS amount FROM production_workers pw
        LEFT JOIN erpx_dev_production.production_log pl ON pl.production_log_id = pw.production_log_id
        LEFT JOIN erpx_dev_masters.village_transport_cost vtc ON vtc.village_name = pw.village
        WHERE pw.contractor_id = ${req.contractorId} AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}' AND pw.transportation = 'Auto'
        GROUP BY vtc.village_name, pl.date
) t`

            //   const finalOtherautoBus = `SELECT SUM(t.no_of_persons) AS total_no_of_persons_Auto
            // FROM (
            //     SELECT DISTINCT p.bill_no, p.no_of_persons
            //     FROM production_log p
            //     LEFT JOIN erpx_dev_production.production_workers pw ON pw.production_log_id = p.production_log_id
            //     WHERE p.contractor_id =  ${req.contractorId} AND p.date BETWEEN '${sixteenDate}' AND '${endOfMon}' AND transportation  IN ('Auto','Bus')
            // ) t`

            const finalOtherautoBus = `SELECT SUM(t.no_of_persons) AS Qty
        FROM (
            SELECT DISTINCT p.bill_no, p.no_of_persons
            FROM production_log p
            LEFT JOIN erpx_dev_production.production_workers pw ON pw.production_log_id = p.production_log_id
            WHERE p.contractor_id =  ${req.contractorId} AND p.date BETWEEN '${firstDate}' AND '${endOfMon}' AND transportation  IN ('Auto','Bus')
        ) t`

            // Fetch `peelingfirstData` only for "First Fortnight" bill type
            if (req.billType === "First Fortnight") {
                firstFortNightData = await manager.query(firstFortNightQuery);
                peelingfirstData = await manager.query(peelingFirst);
                peelingCuttingfirstData = await manager.query(firstPeelingCutting);
                firstOtherData = await manager.query(firstOther)
                firstOtherAutoBusData = await manager.query(firstOtherautoBus)


                if (firstFortNightData.length > 0) {
                    for (const val of firstFortNightData) {
                        firstFortnightDeheading.push(new FirstFortNightDeheading(val.count ? val.count : "-", val.rate ? val.rate : "0", val.totalAmount ? val.totalAmount : "0", val.totalQty ? val.totalQty : "0"));
                    }
                } else {

                    firstFortnightDeheading.push(new FirstFortNightDeheading("-", "0", "0", "0"));
                }

  

                for (const record of peelingfirstData) {
                    console.log(record, "poiuy")
                    // const qwerty = `SELECT pl.scope_of_work, dr.grade, SUM(pl.input_quantity) AS totalQty, SUM(pl.amount) AS totalAmount, pl.unit_price AS rate
                    //     FROM erpx_dev_masters.deheading_peeling_chart dr
                    //     JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
                    //     WHERE pl.operation = 'VALUE ADDITION'
                    //     AND pl.scope_of_work = '${record.scope_of_work}' AND contractor_id = ${req.contractorId}
                    //     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
                    //     GROUP BY  dr.grade`;
//                     const qwerty = `SELECT  
//     t.scope_of_work,
//     t.grade,
//     SUM(t.Qty) AS totalQty,
//     SUM(t.amt) AS totalAmount,
//     t.rate 
// FROM (
//     SELECT 
//         sub.scope_of_work, 
//         sub.grade, 
//         CASE 
//             WHEN 'Non Local' = '${req.contractorType}' THEN sub.actual_output_quantity 
//             ELSE sub.input_quantity 
//         END AS Qty,
//         sub.amount AS amt, 
//         sub.unit_price AS rate
//     FROM (
//         SELECT 
//             pl.production_log_id,
//             pl.scope_of_work,
//             pl.input_quantity,
//             pl.actual_output_quantity,
//             pl.amount,
//             pl.unit_price,
//             pl.input_grade,
//             dr.grade,
//             ROW_NUMBER() OVER (
//                 PARTITION BY pl.production_log_id 
//                 ORDER BY dr.min_grade DESC -- or ASC, depending on preference
//             ) AS rn
//         FROM erpx_dev_production.production_log pl
//         JOIN erpx_dev_masters.deheading_peeling_chart dr 
//             ON dr.scope_of_work = pl.scope_of_work
//             AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
//         WHERE 
//             pl.operation = 'VALUE ADDITION'
//             AND pl.scope_of_work = '${record.scope_of_work}' 
//             AND pl.contractor_id = ${req.contractorId}
//             AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
//     ) sub
//     WHERE sub.rn = 1
//     GROUP BY  
//         sub.grade, 
//         sub.input_quantity,
//         sub.actual_output_quantity,
//         sub.amount,
//         sub.scope_of_work,
//         sub.production_log_id,
//         sub.unit_price
// ) t
// GROUP BY 
//     t.scope_of_work,
//     t.grade;
// `;

        const qwerty = `WITH invalid_bills AS (
    SELECT bill_no
    FROM erpx_dev_production.production_log
    WHERE 
        contractor_id = ${req.contractorId}
        AND date BETWEEN '${firstDate}' AND '${fifteenDate}'
        AND operation IN ('VALUE ADDITION', 'DEHEADING')
    GROUP BY bill_no
    HAVING COUNT(DISTINCT operation) = 2
)
SELECT  
    t.scope_of_work,
    t.grade,
    SUM(t.Qty) AS totalQty,
    SUM(t.amt) AS totalAmount,
    t.rate 
FROM (
    SELECT 
        sub.scope_of_work,
        sub.grade,
        CASE 
            WHEN '${req.contractorType}' = 'Non Local' THEN sub.actual_output_quantity 
            ELSE sub.input_quantity 
        END AS Qty,
        sub.amount AS amt,
        sub.unit_price AS rate
    FROM (
        SELECT 
            pl.production_log_id,
            pl.scope_of_work,
            pl.input_quantity,
            pl.actual_output_quantity,
            pl.amount,
            pl.unit_price,
            pl.input_grade,
            dr.grade,
            ROW_NUMBER() OVER (
                PARTITION BY pl.production_log_id 
                ORDER BY dr.min_grade DESC
            ) AS rn
        FROM erpx_dev_production.production_log pl
        JOIN erpx_dev_masters.deheading_peeling_chart dr 
            ON dr.scope_of_work = pl.scope_of_work
            AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
        WHERE 
            pl.operation = 'VALUE ADDITION'
            AND pl.scope_of_work = '${record.scope_of_work}' 
            AND pl.contractor_id = ${req.contractorId}
            AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
            AND pl.bill_no NOT IN (SELECT bill_no FROM invalid_bills)
    ) sub
    WHERE sub.rn = 1
) t
GROUP BY 
    t.scope_of_work,
    t.grade,
    t.rate;
`
                    const result = await manager.query(qwerty);
                    qwertyData.push(...result);
                }

                // console.log(qwertyData,"pollkk")

                const scopeMap: { [key: string]: ScopeData[] } = {};
                for (const val of qwertyData) {
                    if (!scopeMap[val.scope_of_work]) {
                        scopeMap[val.scope_of_work] = [];
                    }
                    scopeMap[val.scope_of_work].push(new ScopeData(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work));
                }

                for (const [scope, data] of Object.entries(scopeMap)) {
                    firstFortnightPeeling.push(new FirstFortnightPeeling(scope, data));
                }

                // console.log(firstFortnightPeeling,"oppppijjj")

                for (const record of peelingCuttingfirstData) {
   
                    // const qwerty = `SELECT  t.scope_of_work,t.grade,SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM 
                    //       (
                    //      SELECT pl.scope_of_work, dr.grade, CASE WHEN 'Non Local' = '${req.contractorType}' THEN pl.actual_output_quantity ELSE pl.input_quantity END AS Qty,
                    //      pl.amount AS amt, pl.unit_price AS rate
                    //     FROM erpx_dev_masters.deheading_peeling_chart dr
                    //     LEFT JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
                    //     WHERE pl.operation = 'VALUE ADDITION' 
                    //     AND pl.scope_of_work = '${record.scope_of_work}' AND contractor_id = ${req.contractorId} and pl.bill_no = '${record.bill_no}' AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade  AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
                    //     GROUP BY  dr.grade, pl.input_quantity,pl.actual_output_quantity,pl.amount,pl.scope_of_work,pl.production_log_id
                    //     ) 
                    //     t
                    //     GROUP BY t.scope_of_work,t.grade`;

                    const qwerty = `SELECT  t.scope_of_work, t.grade, SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM (
                            SELECT sub.scope_of_work, sub.grade, 
                                CASE 
                                    WHEN 'Non Local' = 'Local' THEN sub.actual_output_quantity 
                                    ELSE sub.input_quantity 
                                END AS Qty,sub.amount AS amt, sub.unit_price AS rate, sub.input_grade
                            FROM (
                                SELECT pl.production_log_id,pl.scope_of_work,pl.input_quantity,pl.actual_output_quantity, pl.amount, pl.unit_price,pl.input_grade, dr.grade,
                                    ROW_NUMBER() OVER (
                                        PARTITION BY pl.production_log_id 
                                        ORDER BY dr.min_grade DESC -- Or ASC for lowest match
                                    ) AS rn
                                FROM erpx_dev_production.production_log pl
                                JOIN erpx_dev_masters.deheading_peeling_chart dr 
                                    ON dr.scope_of_work = pl.scope_of_work
                                    AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
                                WHERE 
                                    pl.operation = 'VALUE ADDITION'
                                    AND pl.scope_of_work = '${record.scope_of_work}' 
                                    AND pl.contractor_id = ${req.contractorId}
                                    AND pl.bill_no = '${record.bill_no}'
                                    AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
                            ) sub
                            WHERE sub.rn = 1
                            GROUP BY sub.grade, sub.input_quantity,sub.actual_output_quantity,sub.amount,sub.scope_of_work,sub.production_log_id,sub.unit_price,sub.input_grade
                        ) t
                        GROUP BY t.scope_of_work,t.grade`

                    const result = await manager.query(qwerty);
                    firstPeelingCuttingData.push(...result);

                }

                for (const val of firstPeelingCuttingData) {
                    firstPeelingCuttingModel.push(new FirstPeelingCuttingModel(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work))
                }


                // const firstForntOther = new FirstOther(firstOtherData[0]?.amount, firstOtherData[0]?.Qty,firstOtherAutoBusData[0]?.Qty)
                const firstForntOther = new FirstOther(firstOtherData[0]?.amount ? firstOtherData[0]?.amount : "0", firstOtherData[0]?.Qty ? firstOtherData[0]?.Qty : "0", "0")   // auto & bus quqntity show in finalFortNight

                const finalForntOther = new FinalOther("0", "0", "0")
                othersModel.push(new OtherModel(firstForntOther, finalForntOther))





            } else if (req.billType === "Final Fortnight") {
                console.log("testuiiii..")
                // Fetch `peelingfirstData` and `peelingfinalData` for "Final Fortnight" bill type
                firstFortNightData = await manager.query(firstFortNightQuery);
                secondFortNightData = await manager.query(secondFortNightQuery);
                peelingCuttingfirstData = await manager.query(firstPeelingCutting);
                peelingCuttingfinalData = await manager.query(finalPeelingCutting);
                firstOtherData = await manager.query(firstOther)
                finalOtherData = await manager.query(finalOther)
                firstOtherAutoBusData = await manager.query(firstOtherautoBus)
                finalOtherAutoBusData = await manager.query(finalOtherautoBus)



                // console.log(firstFortNightData, "lluuul")
                // console.log(secondFortNightData, "lljfkfkl")


                if (firstFortNightData.length > 0) {
                    console.log("klkk")
                    for (const val of firstFortNightData) {
                        firstFortnightDeheading.push(new FirstFortNightDeheading(val.count ? val.count : "-", val.rate ? val.rate : "0", val.totalAmount ? val.totalAmount : "0", val.totalQty ? val.totalQty : "0"));
                    }
                } else {

                    firstFortnightDeheading.push(new FirstFortNightDeheading("-", "0", "0", "0"));
                }

                if (secondFortNightData.length > 0) {
                    for (const val of secondFortNightData) {
                        finalFortnightDeheading.push(new FinalFortNightDeheading(val.count, val.rate, val.totalAmount, val.totalQty));
                    }
                } else {
                    finalFortnightDeheading.push(new FinalFortNightDeheading("-", "0", "0", "0"));
                }





                peelingfirstData = await manager.query(peelingFirst);
                peelingfinalData = await manager.query(peelingFinal);

                for (const record of peelingfirstData) {
                
                    // const qwerty = `SELECT  t.scope_of_work,t.grade,SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM 
                    //       (
                    //      SELECT pl.scope_of_work, dr.grade, CASE WHEN 'Non Local' = '${req.contractorType}' THEN pl.actual_output_quantity ELSE pl.input_quantity END AS Qty,
                    //      pl.amount AS amt, pl.unit_price AS rate
                    //     FROM erpx_dev_masters.deheading_peeling_chart dr
                    //     LEFT JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
                    //     WHERE pl.operation = 'VALUE ADDITION' 
                    //     AND pl.scope_of_work = '${record.scope_of_work}' AND contractor_id = ${req.contractorId}
                    //     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade  AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
                    //     GROUP BY  dr.grade, pl.input_quantity,pl.actual_output_quantity,pl.amount,pl.scope_of_work,pl.production_log_id
                    //     ) 
                    //     t
                    //     GROUP BY t.scope_of_work,t.grade`;

                    const qwerty = `WITH invalid_bills AS (
    SELECT bill_no
    FROM erpx_dev_production.production_log
    WHERE 
        contractor_id = ${req.contractorId}
        AND date BETWEEN '${firstDate}' AND '${fifteenDate}'
        AND operation IN ('VALUE ADDITION', 'DEHEADING')
    GROUP BY bill_no
    HAVING COUNT(DISTINCT operation) = 2
)
SELECT  
    t.scope_of_work,
    t.grade,
    SUM(t.Qty) AS totalQty,
    SUM(t.amt) AS totalAmount,
    t.rate 
FROM (
    SELECT 
        sub.scope_of_work,
        sub.grade,
        CASE 
            WHEN '${req.contractorType}' = 'Non Local' THEN sub.actual_output_quantity 
            ELSE sub.input_quantity 
        END AS Qty,
        sub.amount AS amt,
        sub.unit_price AS rate
    FROM (
        SELECT 
            pl.production_log_id,
            pl.scope_of_work,
            pl.input_quantity,
            pl.actual_output_quantity,
            pl.amount,
            pl.unit_price,
            pl.input_grade,
            dr.grade,
            ROW_NUMBER() OVER (
                PARTITION BY pl.production_log_id 
                ORDER BY dr.min_grade DESC
            ) AS rn
        FROM erpx_dev_production.production_log pl
        JOIN erpx_dev_masters.deheading_peeling_chart dr 
            ON dr.scope_of_work = pl.scope_of_work
            AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
        WHERE 
            pl.operation = 'VALUE ADDITION'
            AND pl.scope_of_work = '${record.scope_of_work}' 
            AND pl.contractor_id = ${req.contractorId}
            AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
            AND pl.bill_no NOT IN (SELECT bill_no FROM invalid_bills)
    ) sub
    WHERE sub.rn = 1
) t
GROUP BY 
    t.scope_of_work,
    t.grade,
    t.rate;`
                    const result = await manager.query(qwerty);
                    qwertyData.push(...result);
                }

                const scopeMap: { [key: string]: ScopeData[] } = {};
                for (const val of qwertyData) {
                    if (!scopeMap[val.scope_of_work]) {
                        scopeMap[val.scope_of_work] = [];
                    }
                    scopeMap[val.scope_of_work].push(new ScopeData(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work));
                }

                for (const [scope, data] of Object.entries(scopeMap)) {
                    firstFortnightPeeling.push(new FirstFortnightPeeling(scope, data));
                }

                for (const record of peelingfinalData) {
             

                    // const qwertyFinal = `SELECT  t.scope_of_work,t.grade,SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM 
                    //       (
                    //      SELECT pl.scope_of_work, dr.grade, CASE WHEN 'Non Local' = '${req.contractorType}' THEN pl.actual_output_quantity ELSE pl.input_quantity END AS Qty,
                    //      pl.amount AS amt, pl.unit_price AS rate
                    //     FROM erpx_dev_masters.deheading_peeling_chart dr
                    //     LEFT JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
                    //     WHERE pl.operation = 'VALUE ADDITION' 
                    //     AND pl.scope_of_work = '${record.scope_of_work}' AND contractor_id = ${req.contractorId}
                    //     AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade  AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
                    //     GROUP BY  dr.grade, pl.input_quantity,pl.actual_output_quantity,pl.amount,pl.scope_of_work,pl.production_log_id
                    //     ) 
                    //     t
                    //     GROUP BY t.scope_of_work,t.grade`;

                    const qwertyFinal = `WITH invalid_bills AS (
    SELECT bill_no
    FROM erpx_dev_production.production_log
    WHERE 
        contractor_id = ${req.contractorId}
        AND date BETWEEN '${sixteenDate}' AND '${endOfMon}'
        AND operation IN ('VALUE ADDITION', 'DEHEADING')
    GROUP BY bill_no
    HAVING COUNT(DISTINCT operation) = 2
)
SELECT  
    t.scope_of_work,
    t.grade,
    SUM(t.Qty) AS totalQty,
    SUM(t.amt) AS totalAmount,
    t.rate 
FROM (
    SELECT 
        sub.scope_of_work,
        sub.grade,
        CASE 
            WHEN '${req.contractorType}' = 'Non Local' THEN sub.actual_output_quantity 
            ELSE sub.input_quantity 
        END AS Qty,
        sub.amount AS amt,
        sub.unit_price AS rate
    FROM (
        SELECT 
            pl.production_log_id,
            pl.scope_of_work,
            pl.input_quantity,
            pl.actual_output_quantity,
            pl.amount,
            pl.unit_price,
            pl.input_grade,
            dr.grade,
            ROW_NUMBER() OVER (
                PARTITION BY pl.production_log_id 
                ORDER BY dr.min_grade DESC
            ) AS rn
        FROM erpx_dev_production.production_log pl
        JOIN erpx_dev_masters.deheading_peeling_chart dr 
            ON dr.scope_of_work = pl.scope_of_work
            AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
        WHERE 
            pl.operation = 'VALUE ADDITION'
            AND pl.scope_of_work = '${record.scope_of_work}' 
            AND pl.contractor_id = ${req.contractorId}
            AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
            AND pl.bill_no NOT IN (SELECT bill_no FROM invalid_bills)
    ) sub
    WHERE sub.rn = 1
) t
GROUP BY 
    t.scope_of_work,
    t.grade,
    t.rate;`
                    const result = await manager.query(qwertyFinal);
                    qwertyFinalData.push(...result);
                }

                const scopeMaps: { [key: string]: ScopeData[] } = {};
                for (const val of qwertyFinalData) {
                    if (!scopeMaps[val.scope_of_work]) {
                        scopeMaps[val.scope_of_work] = [];
                    }
                    scopeMaps[val.scope_of_work].push(new ScopeData(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work));
                }

                for (const [scope, data] of Object.entries(scopeMaps)) {
                    finalFortnightPeeling.push(new FinalFortnightPeeling(scope, data));
                }


                for (const record of peelingCuttingfirstData) {
                   
                    // const qwerty = `SELECT  t.scope_of_work,t.grade,SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM 
                    //       (
                    //      SELECT pl.scope_of_work, dr.grade, CASE WHEN 'Non Local' = '${req.contractorType}' THEN pl.actual_output_quantity ELSE pl.input_quantity END AS Qty,
                    //      pl.amount AS amt, pl.unit_price AS rate
                    //     FROM erpx_dev_masters.deheading_peeling_chart dr
                    //     LEFT JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
                    //     WHERE pl.operation = 'VALUE ADDITION' 
                    //     AND pl.scope_of_work = '${record.scope_of_work}' AND contractor_id = ${req.contractorId} and pl.bill_no = '${record.bill_no}' AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade  AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
                    //     GROUP BY  dr.grade, pl.input_quantity,pl.actual_output_quantity,pl.amount,pl.scope_of_work,pl.production_log_id
                    //     ) 
                    //     t
                    //     GROUP BY t.scope_of_work,t.grade`;

                    const qwerty = `SELECT  t.scope_of_work, t.grade, SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM (
                        SELECT sub.scope_of_work, sub.grade, 
                            CASE 
                                WHEN 'Non Local' = 'Local' THEN sub.actual_output_quantity 
                                ELSE sub.input_quantity 
                            END AS Qty,sub.amount AS amt, sub.unit_price AS rate, sub.input_grade
                        FROM (
                            SELECT pl.production_log_id,pl.scope_of_work,pl.input_quantity,pl.actual_output_quantity, pl.amount, pl.unit_price,pl.input_grade, dr.grade,
                                ROW_NUMBER() OVER (
                                    PARTITION BY pl.production_log_id 
                                    ORDER BY dr.min_grade DESC -- Or ASC for lowest match
                                ) AS rn
                            FROM erpx_dev_production.production_log pl
                            JOIN erpx_dev_masters.deheading_peeling_chart dr 
                                ON dr.scope_of_work = pl.scope_of_work
                                AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
                            WHERE 
                                pl.operation = 'VALUE ADDITION'
                                AND pl.scope_of_work = '${record.scope_of_work}' 
                                AND pl.contractor_id = ${req.contractorId}
                                AND pl.bill_no = '${record.bill_no}'
                                AND pl.date BETWEEN '${firstDate}' AND '${fifteenDate}'
                        ) sub
                        WHERE sub.rn = 1
                        GROUP BY sub.grade, sub.input_quantity,sub.actual_output_quantity,sub.amount,sub.scope_of_work,sub.production_log_id,sub.unit_price,sub.input_grade
                    ) t
                    GROUP BY t.scope_of_work,t.grade`


                    const result = await manager.query(qwerty);
                    firstPeelingCuttingData.push(...result);

                }

                for (const val of firstPeelingCuttingData) {
                    firstPeelingCuttingModel.push(new FirstPeelingCuttingModel(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work))
                }

                for (const record of peelingCuttingfinalData) {

                    // const qwerty = `SELECT  t.scope_of_work,t.grade,SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM 
                    //       (
                    //      SELECT pl.scope_of_work, dr.grade, CASE WHEN 'Non Local' = '${req.contractorType}' THEN pl.actual_output_quantity ELSE pl.input_quantity END AS Qty,
                    //      pl.amount AS amt, pl.unit_price AS rate
                    //     FROM erpx_dev_masters.deheading_peeling_chart dr
                    //     LEFT JOIN erpx_dev_production.production_log pl ON dr.scope_of_work = pl.scope_of_work
                    //     WHERE pl.operation = 'VALUE ADDITION' 
                    //     AND pl.scope_of_work = '${record.scope_of_work}' AND contractor_id = ${req.contractorId} and pl.bill_no = '${record.bill_no}' AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade  AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
                    //     GROUP BY  dr.grade, pl.input_quantity,pl.actual_output_quantity,pl.amount,pl.scope_of_work,pl.production_log_id
                    //     ) 
                    //     t
                    //     GROUP BY t.scope_of_work,t.grade`;

                    const qwerty = `SELECT  t.scope_of_work, t.grade, SUM(t.Qty) AS totalQty,SUM(t.amt) AS totalAmount,t.rate FROM (
                        SELECT sub.scope_of_work, sub.grade, 
                            CASE 
                                WHEN 'Non Local' = 'Local' THEN sub.actual_output_quantity 
                                ELSE sub.input_quantity 
                            END AS Qty,sub.amount AS amt, sub.unit_price AS rate, sub.input_grade
                        FROM (
                            SELECT pl.production_log_id,pl.scope_of_work,pl.input_quantity,pl.actual_output_quantity, pl.amount, pl.unit_price,pl.input_grade, dr.grade,
                                ROW_NUMBER() OVER (
                                    PARTITION BY pl.production_log_id 
                                    ORDER BY dr.min_grade DESC -- Or ASC for lowest match
                                ) AS rn
                            FROM erpx_dev_production.production_log pl
                            JOIN erpx_dev_masters.deheading_peeling_chart dr 
                                ON dr.scope_of_work = pl.scope_of_work
                                AND pl.input_grade BETWEEN dr.min_grade AND dr.max_grade
                            WHERE 
                                pl.operation = 'VALUE ADDITION'
                                AND pl.scope_of_work = '${record.scope_of_work}' 
                                AND pl.contractor_id = ${req.contractorId}
                                AND pl.bill_no = '${record.bill_no}'
                                AND pl.date BETWEEN '${sixteenDate}' AND '${endOfMon}'
                        ) sub
                        WHERE sub.rn = 1
                        GROUP BY sub.grade, sub.input_quantity,sub.actual_output_quantity,sub.amount,sub.scope_of_work,sub.production_log_id,sub.unit_price,sub.input_grade
                    ) t
                    GROUP BY t.scope_of_work,t.grade`

                    const result = await manager.query(qwerty);
                    finalPeelingCuttingData.push(...result);

                }

                for (const val of finalPeelingCuttingData) {
                    finalPeelingCuttingModel.push(new FinalPeelingCuttingModel(val.grade, val.rate, val.totalAmount, val.totalQty, val.scope_of_work))
                }


                // const firstForntOther = new FirstOther(firstOtherData[0]?.amount, firstOtherData[0]?.Qty,firstOtherAutoBusData[0]?.Qty)
                const firstForntOther = new FirstOther(firstOtherData[0]?.amount ? firstOtherData[0]?.amount : "0", firstOtherData[0]?.Qty ? firstOtherData[0]?.Qty : "0", "0")   // for auto and bus noof worker shown in finalfort

                const finalForntOther = new FinalOther(finalOtherData[0]?.amount ? finalOtherData[0]?.amount : "0", finalOtherData[0]?.Qty ? finalOtherData[0]?.Qty : "0", finalOtherAutoBusData[0]?.Qty ? finalOtherAutoBusData[0]?.Qty : "0")
                othersModel.push(new OtherModel(firstForntOther, finalForntOther))

            }





            if (firstFortNightData || secondFortNightData || qwertyData) {

                const contractorName = firstFortNightData.length > 0 ? firstFortNightData[0].contractor_name : secondFortNightData[0]?.contractor_name;

                const response = new BillGenerationModel(
                    contractorName,
                    firstFortnightDeheading,
                    finalFortnightDeheading,
                    firstFortnightPeeling,
                    finalFortnightPeeling,
                    firstPeelingCuttingData,
                    finalPeelingCuttingModel,
                    othersModel
                );

                return new CommonResponse(true, 1, "Data retrieved", response);
            } else {
                return new CommonResponse(false, 0, "No data", []);
            }
        } catch (err) {
            console.error("Error retrieving contractor-wise bill generation data:", err);
            return new CommonResponse(false, 1, "Something went wrong", err);
        }
    }

    async wagesPayableVillageWise(req:TransportChargesReq):Promise<CommonResponse>{
        const manager = getManager()
        try{
            await manager.query(`SET @slNo := 0;`);
            await manager.query(`SET @current_contractor := '';`);
            let query = `
            SELECT 
                contractorName, 
                slNo, 
                village_name AS villageName, 
                noofworkers AS noOfWorkers, 
                manDays, 
                total_wages AS totalWages 
            FROM (
                SELECT 
                    CASE 
                        WHEN village_name = 'Total' OR village_name = 'Grand Total' THEN '' 
                        ELSE COALESCE(contractorName, '') 
                    END AS contractorName,
                    IF(village_name = 'Total' OR village_name = 'Grand Total', '', 
                    IF(@current_contractor = contractorName, 
                        @slNo := @slNo + 1, 
                        @slNo := IF(@current_contractor := contractorName, 1, 1)
                        )
                    ) AS slNo,
                    CASE 
                        WHEN contractorName IS NULL AND village_name = 'Total' THEN 'Grand Total' 
                        ELSE village_name 
                    END AS village_name,
                    noofworkers,
                    manDays,
                    total_wages,
                    sort_contractor_id,
                    row_type
                FROM (
                    -- Individual contractor village summaries
                    SELECT 
                        c.contractor_name AS contractorName,
                        COALESCE(vtc.village_name, 'Total') AS village_name,
                        SUM(CASE WHEN vtc.village_name IS NOT NULL THEN base_data.worker_count ELSE 0 END) AS noofworkers,
                        SUM(CASE WHEN vtc.village_name IS NOT NULL THEN base_data.manday_count ELSE 0 END) AS manDays,
                        SUM(base_data.wage_total) AS total_wages,
                        COALESCE(base_data.contractor_id, 999999) AS sort_contractor_id,
                        CASE 
                            WHEN vtc.village_name IS NULL AND base_data.contractor_id IS NULL THEN 99 -- Grand Total
                            WHEN vtc.village_name IS NULL THEN 1 -- Contractor subtotal
                            ELSE 0 -- Regular village row
                        END AS row_type
                    FROM (
                        -- Base query with proper counting
                        SELECT 
                            pl.contractor_id AS contractor_id,
                            w.village_from_id AS village_from_id,
                            COUNT(DISTINCT pw.emp_code) AS worker_count,
                            COUNT(DISTINCT CONCAT(pw.emp_code, pl.date)) AS manday_count,
                            SUM(pw.avg_wage) AS wage_total
                        FROM ${appSettings.production_db}.production_workers pw
                        LEFT JOIN ${appSettings.production_db}.production_log pl ON pl.bill_no = pw.bill_no
                        LEFT JOIN ${appSettings.masters_db}.workers w ON w.worker_code = pw.emp_code
                        WHERE 1=1 
                        ${req?.fromDate ? `AND pl.date BETWEEN '${req?.fromDate}' AND '${req?.toDate}'` : ''}
                        ${req?.contractorId ? `AND pl.contractor_id = ${req?.contractorId}` : ''}
                        ${req?.villageId ? `AND wo.village_from_id = ${req?.villageId}` : ''}
                        GROUP BY pl.contractor_id, w.village_from_id
                    ) AS base_data
                    LEFT JOIN ${appSettings.hrms_db}.contractor c ON c.contractor_id = base_data.contractor_id
                    LEFT JOIN ${appSettings.masters_db}.village_transport_cost vtc ON vtc.village_transport_id = base_data.village_from_id
                    GROUP BY c.contractor_name, vtc.village_name WITH ROLLUP
                    
                    UNION ALL
                    
                    -- Grand Total calculation
                    SELECT 
                        NULL AS contractorName,
                        'Total' AS village_name,
                        SUM(worker_count) AS noofworkers,
                        SUM(manday_count) AS manDays,
                        SUM(wage_total) AS total_wages,
                        999999 AS sort_contractor_id,
                        99 AS row_type
                    FROM (
                        SELECT 
                            pl.contractor_id,
                            COUNT(DISTINCT pw.emp_code) AS worker_count,
                            COUNT(DISTINCT CONCAT(pw.emp_code, pl.date)) AS manday_count,
                            SUM(pw.avg_wage) AS wage_total
                        FROM ${appSettings.production_db}.production_workers pw
                        LEFT JOIN ${appSettings.production_db}.production_log pl ON pl.bill_no = pw.bill_no
                        WHERE 1=1 
                        ${req?.fromDate ? `AND pl.date BETWEEN '${req?.fromDate}' AND '${req?.toDate}'` : ''}
                        ${req?.contractorId ? `AND pl.contractor_id = ${req?.contractorId}` : ''}
                        ${req?.villageId ? `AND wo.village_from_id = ${req?.villageId}` : ''}
                        GROUP BY pl.contractor_id
                    ) AS grand_total_data
                ) AS subquery
            ) AS final_result
            ORDER BY 
                CASE WHEN village_name = 'Grand Total' THEN 1 ELSE 0 END,
                sort_contractor_id,
                row_type,
                village_name;`;

                let data = await manager.query(query);

                if (data.length > 0) {
                    data.pop();
                }
            if (data.length > 0) {
                return new CommonResponse(true, 1, 'data retreived', data);
            } else {
                return new CommonResponse(false, 1, 'No data', []);
            }
        }catch(err){
            throw(err)
        }
    }

    async getContractorAndDayWiseData(req?: TransportChargesReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
            await manager.query("SET SESSION group_concat_max_len = 1000000");
    
            let dateColumnsQuery = `
            SELECT
                GROUP_CONCAT(DISTINCT
                    CONCAT(
                        'COUNT(DISTINCT CASE WHEN pl.date = ''', 
                        date, 
                        ''' THEN pw.emp_code END) AS \`',
                        DATE_FORMAT(date, '%d %b'),
                        '\`'
                    )
                ) AS columns
            FROM (
                SELECT DISTINCT pl.date
                FROM production_log pl
                LEFT JOIN erpx_dev_production.production_workers pw USING (production_log_id)
                LEFT JOIN erpx_dev_masters.workers wo ON wo.worker_code = pw.emp_code
                WHERE pl.contractor_id IS NOT NULL
                    AND wo.village_from_id IS NOT NULL
                    ${req?.fromDate ? `AND pl.date BETWEEN '${req?.fromDate}' AND '${req?.toDate}'` : ''}
                    ${req?.contractorId ? `AND pl.contractor_id = ${req?.contractorId}` : ''}
                    ${req?.villageId ? `AND wo.village_from_id = ${req?.villageId}` : ''}
                    AND pl.no_of_persons > 0
            ) valid_dates`;
    
            const dateColumnsResult = await manager.query(dateColumnsQuery);
            const dynamicColumns = dateColumnsResult[0]?.columns || '';
    
            const mainQuery = `
                (
                    SELECT 
                        pl.contractor_id AS contractorId,
                        c.contractor_name AS contractorName,
                        wo.village_from_id AS villageId,
                        vtc.village_name AS villageName
                        ${dynamicColumns ? `, ${dynamicColumns}` : ''},
                        COALESCE(COUNT(DISTINCT pw.emp_code), 0) AS total
                    FROM production_log pl
                    LEFT JOIN erpx_dev_hrms.contractor c USING (contractor_id)
                    LEFT JOIN erpx_dev_production.production_workers pw USING (production_log_id)
                    LEFT JOIN erpx_dev_masters.workers wo ON wo.worker_code = pw.emp_code
                    LEFT JOIN erpx_dev_masters.village_transport_cost vtc ON vtc.village_transport_id = wo.village_from_id
                    WHERE pl.contractor_id IS NOT NULL 
                        AND wo.village_from_id IS NOT NULL
                        ${req?.fromDate ? `AND pl.date BETWEEN '${req?.fromDate}' AND '${req?.toDate}'` : ''}
                        ${req?.contractorId ? `AND pl.contractor_id = ${req?.contractorId}` : ''}
                        ${req?.villageId ? `AND wo.village_from_id = ${req?.villageId}` : ''}
                    GROUP BY pl.contractor_id, c.contractor_name, wo.village_from_id, vtc.village_name
                    HAVING total > 0
                )
                UNION ALL
                (
                    SELECT 
                        pl.contractor_id AS contractorId,
                        c.contractor_name AS contractorName,
                        NULL AS villageId,
                        'Total' AS villageName
                        ${dynamicColumns ? `, ${dynamicColumns}` : ''},
                        COALESCE(COUNT(DISTINCT pw.emp_code), 0) AS total
                    FROM production_log pl
                    LEFT JOIN erpx_dev_hrms.contractor c USING (contractor_id)
                    LEFT JOIN erpx_dev_production.production_workers pw USING (production_log_id)
                    LEFT JOIN erpx_dev_masters.workers wo ON wo.worker_code = pw.emp_code
                    LEFT JOIN erpx_dev_masters.village_transport_cost vtc ON vtc.village_transport_id = wo.village_from_id
                    WHERE pl.contractor_id IS NOT NULL 
                        AND wo.village_from_id IS NOT NULL
                        ${req?.fromDate ? `AND pl.date BETWEEN '${req?.fromDate}' AND '${req?.toDate}'` : ''}
                        ${req?.contractorId ? `AND pl.contractor_id = ${req?.contractorId}` : ''}
                        ${req?.villageId ? `AND wo.village_from_id = ${req?.villageId}` : ''}
                    GROUP BY pl.contractor_id, c.contractor_name
                    HAVING total > 0
                )
                ORDER BY contractorName, villageName = 'Total', villageName`;
    
            const data = await manager.query(mainQuery);
    
            return data.length > 0 
                ? new CommonResponse(true, 1, 'Data retrieved', data)
                : new CommonResponse(false, 1, 'No data found', []);
        } catch (err) {
            throw err;
        }
    }
    







}
